var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _polygon, _polygon2, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _polygon3, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _polygon4, _path34, _path35, _path36, _path37, _path38, _polygon5, _path39, _path40, _path41, _path42, _polygon6, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _polygon7, _path50, _path51, _path52, _polygon8, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _polygon9, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTowerBridge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 801 669",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 2px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.6,453.3l25.4-.2,19-.7c.7-.7.6-4-.4-4.5l-42.6.4-49.2,1-17.5.3c-.8,0-3.3-1.5-2.4-1.3,1.8-1.2,3.5-2.4,3.8-3.7,1.1-4-7.3-4.4-3.3-6.2s2.6-9.4,2-9.3l-3,.6c-.3-.6.7-3.7,1.9-4.4,19.7-12.2,37.4-25.6,54.6-41.2,33.3-30.3,61.8-64.1,86.3-102.3l-.4-65.8c0-1.7-.9-5.1-.5-6.6l10.1-35.4c.7-2.4-.9-5-2.1-6,1.2-1.4,2.4-3.3,2.8-4.7l.9-3.3c.9,3.3,1.6,5.2,2.9,7.4-6,1.9,4.2,24.6,5.6,30.7,1.9-.5,3-1.6,3.6-2.8l3.7-7.3,4.7,3.6c6.6-12,12.7-23.6,18.2-36l3.5-7.9c.7-1.6.6-5.3.9-8.2l3,2.1c11.8-13.9.7-9.7,7.2-17.9l.7,8.5c.3,3.2,3.1,7.8,4.6,10.5l3.3-1.8c1.1,10.9-.9,6.6,3.8,17,7.9,17.6,15.8,34,25.1,51.7l9.1-32.7c.4-1.5-1.1-4.7-1.5-5.8l2.4-7.3c1.2,2.9,2.4,5.5,3.3,7-7.1,1.4,7.9,32.6,8.1,41.3l.6,30.4,32.8-3.6,1.9-4.4c.3-.6.9-1.6,1.3-2.1s2.6.2,2.9.9c.6,1.2,1.9,3.3,3,4.9l-1.9.4c-.8.2-2.1-1.7-3.6-3.3-.4,8.6-.7,17.2.1,26.7,3.4-6.9.3-14,1.5-20.3l5.4-2.1c.8-5.6,1.8-10,4.4-15.3,3.7,3.7,2.9,9.7,7.4,11.4,1.1-3.2,1.6-5.1,3-5.4,5.8-1,2.6,6.3,6.7,5.8l43.9-4.8c5.9-.7,11.3-.9,17-1.5l46.3-4.5v-12.3c.1-11.2-1.4-22.7-.3-33.6,1.4-14,15.4-43.7,8-44.5,2-1.4,3.1-4,3.3-6.8.5-1.5.9-2.6.5-1.2l3.5,6.9c-.7.8-2.9,4.3-2.4,5.9l8.3,27.4c6.7,1.2,6.6-7.1,10.7-11.8l4.4,1.8,17.6-36.3c1-2,1.8-5,2.6-7.4s.8-6.4,1.3-9.9l3.1,3.5,4.4-8c1.5-2.8,1.1-6.2-.9-8.7l2.8-4,2.3,4.2c-.9,1.8-1.9,5.1-1.2,6.7l4.7,10.3,3.3.2c.2,3,0,6.6.7,9,3.6,13.7,15,36.4,21.5,49.5,8.6,3.6,2.7,8.1,7.9,12l9.7-32.5c.2-.6.1-2.8-.4-3.1l-2.8-1.8c1.4-1.4,3-3.3,3.2-4.7l1-6.5c1,4.1,1.9,7,3.3,9.5-6.5,4.9,6.9,31.2,7.7,41.9,2.1,26-.2,51.5.5,78.2,27.1,32.9,58,62,92.2,87.7,38.3,28.7,76.7,52.1,121.9,68.3,1.3.5,2.9,2.7,2.6,3.7l-11.2,1.9c3.2,3.3,5.9,3.7,10.2,5,.9,2.2,1.3,5.6,1.3,8.7l-27.8.4c-1.6,0-2.4,4.6-1,4.6l28,.7c-4,.5-8.4,1.5-12.1,1.5l-78.8.3h-20.3c0,.1-140.8.5-140.8.5-1.5,0-1.4,5.5-.1,5.6l34.1.6,88,.3,112.3.5,18.8.7c-3.5.8-7.3,1.6-11.1,1.5l-119.4-.7-121.6-.4c-2.5,0-2.5,4-1.7,4.3s2.3.7,3.6.7l77.1.9,110.8,1,50.9.5c3.1,0,7,.9,10.3,1.6l-123-.6-55.4-.4-.6,46.8-13.1,1-60,3-24.1,1-30,1c-16.5.6-32.5.4-49,0s-14.9-1.7-22.9-3.2c-4.1-24.7,10-21.7,4.9-33-22.1-5.7-44-14.4-67-14.7s-56.7,11.1-56.9,14.7,7.8,7.2,7.1,18.3l-.5,7.7-35.9,2.8-52.7,2.6-38,1.2h-37c-8.9,0-16.7-.9-25.7-2.4-.4-5.2-2-10.5.5-14.3l8.2-12.6c3-4.7.6-12.3.6-18.4l-42,.6-67.9.7c-1.2,0-3-1.6-2.7-1.6s1.8-.3,2.1-.3l90.9-1.2,16.9-.4c.6,0,2.2-.7,2.6-.9.7-.3-.7-2.8-1.6-2.8l-47.2.6c-21.9.3-42.6.9-63.8.4,4.9-.7,9.6-1.1,14.1-1.2l17-.3,29-.3,7.6-.7ZM524.6,117.2l-7.5-18.1-7.6,15.1c5.6,1.8,9.2,2.7,15.1,3ZM497.3,171.2l10.6-37.6c.5-1.7-1.1-4.9-2.1-5.8l2.4-3.4c.6-.8-1-3.8-2-3.6l-19,39.9,7,2.3,3.1,8.3ZM528.3,198.2c2.2-17.7-3.3-13.2,1.3-32.3l8.2-2.2c1.9-.5,3.3-5.5,3.4-7.6l-14.6-32.5-16-3.3c.1,2.3.5,4.7.8,6.3l3.8-2.6-4.1,5.3c-.6.8-.5,3.7-.2,4.6l11,37.3c2.6,8.9-5.6,30.7,6.5,27ZM225.4,151.7c-.6-3.5-1.3-5.2-2.5-7.3l-5-8.7-6,8.5c-.9,1.2-1.6,3.5-1.5,5.3l15,2.2ZM511.5,172.5l-2.7-33.3c-4.2,12.4-6.6,22.4-9.7,34.2l12.4-.9ZM520.1,173.5l-7.8-26.9c-.7,9.6.1,17,.7,26.4l7.1.5ZM460.9,178l.3-19c0-3.9,0-7.4-.8-11.2l-9,31,9.4-.8ZM462.8,178.4l8.5.2c-2.1-10.9-4.3-19.4-7.9-28.9-.7,6.2-.5,11.4-.5,17.3v11.4ZM568.5,183l-2-30.4-9.3,30.6,11.3-.2ZM226,198.3l8.1-1.9,5.1-6.5,3.9,6,1.5,2.3c.3.5,2.4-.7,2.4-1.1l-18.7-40.2-19.9-3.1c-1.3.5-3.4,4.3-2.6,5.4s1.7,2.2,2.7,3.4c-1.9,1.2-3.1,3.7-2.4,6,3.8,13,7.9,25.3,10.8,38.4s-2.3,12.6-.1,18.9c2,1,5.3,1.3,8.4,1.1v-16.4c-.1-3.8.6-8.5,1.1-12.4ZM488.2,200.6l.7-7.1c.8,2.6,1.9,5.8,2.9,7.8-1.1,2.1-2.9,6.4-.1,8.7l6.2-1.1v-9.9c-1.2,2.3-1.4,3.1-3.1,4.4-2.1-8.5-3-15.8-3.8-24.6l-6.7-10.4,1.2-1.1,5.2,8.4c.3-4.6-1.7-6.7-3.4-9.6s-2.1-6.1-4.9-8.7l-4.7,9.5,2.4,1.6-5.4,7.3c-1.8,2.5-2.4,21.3-1.5,25.7,2.6-.3,3.1-1.9,3.1-3.5v-3.1c0-.5,1.4-.4,1.9-.4l1.2,5.8,1.8-7.3c1.2,2.2,1.5,3.7,2.2,7l1-4,.2-1.8c0-.4,1.5-.8,1.6-.4l.5,2.1,1.1,4.5ZM577.3,183.3l-8-25.6c-.9,9.2-.3,16.4.7,25.4,2.9.3,5.2.4,7.3.2ZM534.4,189.2l-1.2,23.1,18.6,2.8-.5-13c-.3-8.3.1-16.1-.7-24.3-.8-1.4-2.8-4.4-3.3-5.8-1-3.7-2-6.8-4.2-11l-5.4,10.1c-2.7,4.9-5.2,10.6-3,15.8l5.3,1.1.5,20.2-5.6-.9.5-14.4,2.1-2.4c.5-.6-3-1.9-3.1-1.1ZM194,201.3l9.3-33.5c.2-.8,0-2.7-.3-3s-1.1-.6-2,1.2l-13.8,27.6c4.2.8,4.8,3.6,6.8,7.6ZM495.2,173.5c-1.5-3.5-3-7.3-5-9.7l2.8,8.9c.1.3.8,1.7,1,2s1.1-.8,1.2-1.2ZM538.2,167.1h-6.2c-.7,3.1-.9,5.3-.2,9.2,3-3.7,3.4-4.4,6.4-9.2ZM474.7,173.7l2.3-4.5c-2.7,1.2-3.9,3.4-2.3,4.5ZM551.3,174.5l.8-3.8c.1-.6-2.5-.6-3.1-.4l2.2,4.3ZM519.2,180.8c.7-.3.9-3.7.2-4.4-6.2-1.3-14.4-1.6-20.7.5s0,4.2,1.2,4.1c6-.6,13.1-.5,19.2-.2ZM204.3,204.6v-9.5c0-6.7.2-12.4-.7-19.3-3.2,10-5.5,18.6-8.2,29.4,3.6,0,7-.3,8.9-.6ZM497.2,192.8l-.7-16.4-3.3-.2,2,20.9c1.1-.9,2.1-2.8,2-4.3ZM531.9,176.3c-2.1,1.5-2.2,3-1.9,4.3l1.7,6.6.2-10.8ZM214.4,205.6c-2.9-10.3-5-17.8-8.2-27l-.4,26,8.6,1ZM553,180.5c.3.7,1.4,3,1.5,2.5l.5-2.6c0-.3-2.2-.2-2.1.1ZM470.3,185.7l.4-4.5c-6.7-.6-12.6-.6-19,.1l.4,4.3h18.2ZM163.3,208.2l.3-10.2c.2-5.6,0-10.3,0-16.2l-7.9,27.2c2.7.6,6.7.6,7.7-.8ZM500.2,208.4l19.9-.2-.3-24.6c-6.6-1.9-13.2-1.7-20.8-.2-.1,6.1.1,11.4.6,17.5l.6,7.4ZM171.7,209.2c.8-11.8-1.8-16.4-5.4-26.5-.5,4.9-.8,8.8-.9,13.2l-.3,13.3h6.6ZM265.2,211.2l.3-7.3c.3-6.6.4-12.5-.4-18.7l-7.3,26.6,7.4-.6ZM275.7,211.8l-8.3-27-.6,26.3c3.5.6,6.1.8,8.9.8ZM558.2,203.5c-.5-3.5-1-8.2-1.9-10.7l-3-8.1v15.3c0,1,.9,3,1.6,3.5s2.8.2,3.3-.1ZM576.4,190.4c.6-.4.9-3.5.5-4.5l-19.2-.5c-.5,1.4-.3,4.6.2,4.9h18.5ZM473.1,203.5l-4.3,3.2-2.1-6.8c5.4-2.5,4-5.7,3.5-11.8-6.7-.8-11.6-.8-18.2,0v24.9s12.9-.6,12.9-.6c8.6-.4,16-1.3,24.9-2.2l-.6-7.9-16.2,1.3ZM193.1,237.2c7.5-1.5,13.3-2.8,21.2-.9l-.3-22.1c-6.5-1.4-13.3-1.6-18.9.6,0,5-.3,11.6-.7,15.2s-2.3,1.3-2.5.8c-3-7.4-2.3-17.1-4.2-21.1l-5.9-12.4c2.8,2.8,4.2,5.7,6.3,8.9-1-5.8-3.3-10-6.4-15.2-2,3.5-2.8,6.5-3.2,10.5l-4.4,6.8-.7,23.7c-1.4.2-4.1.6-4.4-.2l-.9-2.3c5.3-2.9,3.4-5.2,3.7-11.6l-15.6.3v22.2s13-.6,13-.6c7.8-.3,16.1-1.1,24-2.6ZM522.4,210.8l9,1.3.4-20.4-.9,6.5c-.2,1.4-2.9,4-3.8,4.3l-4.9-3,.2,11.3ZM553.3,215.9c6.4.8,10.4,1.2,15.8,1.4l7.9.3v-24.8c-6.7-.9-11.7-.9-18.2-.3l2.1,10.6,2.5,3.4c.5.6-1.5,2.7-1.8,2.3l-8.1-3.5v10.5ZM537.5,203.1c.6-3.7.6-7,0-10.2-.6,3.7-.6,7,0,10.2ZM248.6,240.7l-.4-13.8c-.2-6.5,1.3-14.1-2.1-20.1s-2.8-3.3-3.2-4.5c-.9-2.9-2-5.5-3.8-8.5l-7.2,12.3c-3.6,6.1-2.6,14.9-3,21.9l-.5,10.8,20.3,2ZM191.6,207c.4-3.6,0-5.4-.9-7.4l-1.1-2.6c-.2-.4-2.1.2-2.4.3.8,1,2.2,2.8,2.6,4l1.9,5.7ZM228,206.9l4.6-4.6,1.9-3.3-6.1,1-.4,6.9ZM247.3,202.4c1,0,.2-3.2-.6-2.6s-1,.9-1.9,1.7.5,1,2.5.8ZM469.1,201.2l.2,2.8c0,.4,1-.7,1.2-1l.6-1.4c.1-.3-2-.7-2-.4ZM257,231.1c-.1-9.9-1.7-18.5-6.8-26.4l.2,24.6c1.8,1.2,4.4,2,6.6,1.8ZM213.2,211.6c.6,0,2.3-1.8,1.9-2.1-5-4-26.1-2.9-20,2.3,5-.6,13-.7,18.1-.1ZM192.6,225.1c.7-5.8.6-11.5-1.2-17.2l-.4,7,1.6,10.2ZM227.5,215.1c.4-2.7.4-5,0-7.2-.4,2.7-.4,5,0,7.2ZM516.9,246.7c0-.8,2.4-3.3,2.7-3.7v-31.5c-6.5-1.2-12.7-1.3-19.2-.1v43.6s16.6-.6,16.6-.6v-7.6ZM171.8,215.9l-.7-4.2-14.6.2c-1,0-.5,5,0,4.2l15.4-.2ZM493,225.8l2.3,12-5.2.3c-.7.2-1.2,4.1-.3,4.4l3.8,1.2c.8.3,2.6,1.2,2.5,1.4-9.5-.2-17.6.2-26.1,2l4.6,7.4,1.4-5.9,2.9,5.8-6.2.8c-.3-.2-1.5-2.5-2-3.7l-1.8-4.4c.9-1.3,1.6-3.8,1.4-5.4s-1.6-2.1-3.3-2.9l-.4,19.9,31.8-2.7v-44.3s-32,3.2-32,3.2l.4,23.2,3.6-.2c1.9,0-.4-9.8,1.6-10.2,1.3-1.1,1.9,14.7,4.1,9.2s.6-1.6.7-2l.3-5.7c0-.3.6-1.5.9-1.5h1.5s1,7.5,1,7.5l.9-8.1,2.3,1.9c-.5,2.8-.2,2,.4.1l1.1-2.5c.1-.3,1.1-.2,2.3-.3l.9,7c0,.7,1.4,2.1,2,2.5,2.8,2,0-10.2,2.6-10ZM563,262.7v-38.8c0-1.2-.4-3.7-1.3-4.1s-2.6-.9-3.6-1l-36.6-5.7v34c.1,0,9.5,12,9.5,12l32,3.7ZM273,217.7h2.8c.4.2,0-2.6-.4-2.7-3.8-1.3-21.8-3.1-16.9,2.9,5.4-.3,9.8-.4,14.5-.1ZM464.9,258v-25s-.6-17.8-.6-17.8c-4.4-.5-8.8-.4-11.5,1.4v42.1c0,0,12.1-.7,12.1-.7ZM266,242l9.4.4v-21.8c-5.8-.9-10.4-1.1-16.7-.5l.9,14.4-9.4-1.4-.2,8.2,16,.8ZM576.6,256.3v-35.8c-4.2-.7-7.2-.9-11.7-1v8.5s.2,34,.2,34c3.4.5,7.3.4,10.3-.1.4-2.1,1.2-4.4,1.2-5.6ZM216.3,237.2l10.1,1.2.3-11.4-1.8,2.5c-.4.5-2,.3-2.8.2l-5.9-.8v8.4ZM412.5,233.2l8.5-.9,9.9-1,10.1-.9,9.3-.6c-.9-2.5-1.1-2.5-2-2l-11.4,1.1-9.1.9-10,1-9,1-7.8,1c4,2.4,7.2.9,11.4.5ZM327.6,237.8c3.8,1.1,5.2,1.5,8.6,2.1l.2,17.1c0,.8,0,2,.4,2h1.6c.4,0,.5-1.3.4-2.1l-.4-22.5c0-.7-1.2-2.4-1.3-1.9l-.7,2c-.3,1-2,3-3,3s-2.2-.8-3-1.4l-4.7-4.1-3.3,8.7-4.9,3.4v16.6s17.1-1.3,17.1-1.3v-14.6c-.1-5.2-5.3-1.5-7.1-6.8ZM399.7,253.3l-.4-21.5-7.8.7v21.8c3.1.2,6.5-.2,8.2-1ZM420.1,244c1,1.3,5.4,1.4,6.3,0s.1-1.9,0-2.3c-.2-1.9,2.7,2.9,5.9,2.5s2.8-2,3.8-3l4.5,2.1c1.1.5,3.3-1.5,4.4-3.2l3.2,1.8c.6.3,2.8-.7,2.4-1.3s-1.2-2-1.7-2.5l-1.7-1.7c-.3-.3.9-1.4,1.3-1.7l1.4-1.3c.3-.3-.4-1.6-.8-1.5l-2.1.7c-.9.3-2.8.4-4.3.2-2.3-.3-4.9.5-6.9.7l-8.9.7-8.4.8-10.1,1.1c-1.6.2-5.3.1-6.2,1.3-1.5,2.1-.8,7.4,1.6,8.7s4.7-1.9,5.7-3.8c1.3,1.4,2.7,3.2,3.9,3.4s3.8-.7,4-1.8.5-2.5.9-2.1l1.7,2.1ZM352.3,238.7l9.7-.9,10.9-1,8.1-.6c3.2-.2,5.5-.4,8.2-1.7-3.1-.3-5.6-.4-8.1-.1l-10.2,1-10.9,1.1-10,1c-3.3.3-6.3.7-9.8,2.1,4.3,0,7.8-.3,12-.7ZM203,264.9c2.8-.6,4.9-1.2,5.1-2l-.2-13.2,6.1-1.5v-9.3c-6.2-1.4-11.6-1.7-17.8.5v39.8c11.1-2.1,12.8.6,18.6-.4s-.7-2.1-1.3-2.3l-10.2-3-.3-8.6ZM355.4,249c1.1.4,3.9,1.9,4.9,1.3l3.5-2.1c2.6,1.7,6.2,1.3,8.4-.7,5.9,2,4.2,1.8,8.5-.8,1.9.9,5.7,1.8,6.7.3,1.8-2.4,2.9-6.5,1.3-8.7-1.4-.7-5.3-.6-6.5-.3,1.1,1.6,1.8,3.1,2.5,2.8l2.7-.9-2.2,4.6c-1.3-5-7.2-7-10.4-5.8s-1,1.4-1.2,1.8-1.6-.1-2.1-.4c-3-1.5-5.7.2-8.1.3s-5.4.2-8.2.5l-8.8,1.1-5.1.2,3.2,4.5-2.7,1.1c-.7.3-.9,2.6-.3,2.9s2.7.5,3.2,0l2-1.8c.2-.2.9.6,1.7,1.2,2,1.5,5.2.4,7.2-1.3ZM472.8,244.6l14.2-1.6v-5.1c.1,0-14.8,1.2-14.8,1.2l.6,5.4ZM255.2,244.4c-7.1-1.6-14.1-2.5-21.6-3.2l-17.2-1.8c-.3,3-.3,6.4,0,9l38.8-4ZM168.2,282.1l26.1-2v-40.5s-26.1,2.9-26.1,2.9v24.5c0,0,0,15.2,0,15.2ZM288.1,245.3l9.1-.9,11.8-1.2c.5,0,1.7-.4,2.1-.5s0-1.6-.4-1.5l-1.7.5-11,1.1-9,.9-10,.9-11.7.9c-4.6,2.8,22.3-.4,20.9-.3ZM166.4,281.9v-17.9c0,0-.2-21.2-.2-21.2-2.5-.8-7-.6-9.7,1l.2,38.9,9.7-.7ZM265.4,264.8l.3-20h-7.5c0,.1.3,20.4.3,20.4.7,1.3,6.9,1.2,6.9-.4ZM294.1,248.8v-1.3c.1-2-6.5,1.5-8,1.5-.8-1.6-3.9-1.1-5.5-.1l1.6,2.3-6.9-2.4c-.5-.2-2.3.5-2.8.8-1.5.9,2.3,1.2,4.3,4.9s-1,.9-2.1,1c-1.7.2-2.6-5.5-4.2-3.3l-2,2.7c-.3.5,0,2.8.6,2.7l2.7-.7c2.2,1,4.5,1.4,6.7-.4l6,.8,5.7-3.3c0,.7-.2,2.3.5,2.3s2.7,0,3.3-.4l3.4-1.6,2.7,1.4,5.3-2.4,4.8,1.9c2.2-3.1,2.2-6.6.9-10.1l-5.3.7,3.9,3.4c.4.3.9,1.7,1.1,2.1s-1.9,1-2.2.6l-1.2-2c-.6-1.1-1.7-2.6-2.6-2.8-1.5-.4-4.6,7.8-5,4.3s4.4-2.3,3-5.5c-3.6.8-6,1.7-8.4,2.8ZM449.6,249.6c1.3-.1.8-5.4-.5-5.2l-47.5,4.2c-.7.9,0,5.2,1.3,5.1l46.6-4ZM214.6,252.4l10.5-1.1,10.9-1.1,9.1-.9c4-.4,7.4-.9,11.1-1.9-3.7-.2-6.7,0-10.1.4l-10.1,1-9,1-9,1-8.6.9c1.5,1.6,3.1.9,5.3.7ZM255.7,250.2l-3.9,2.7c-1,.7-2.4,2-2.9,2.9s1.9,3,3,3c2.1,0,4.9-8.1,3.9-8.5ZM388.6,255c1.1-1,.9-5.4-.4-5.3l-46.9,4,.4,5.4,46.8-4.1ZM234.3,257.4c1.8,1.3,5,3.4,6.4,4.3l4.8-3.4c.7,1.4,1.2,2.6,2,2.5,1.3-.2,3.2-1.6,1.8-2.3l-2.7-1.4c0,.3,0-1.5,0-2.2s1.6-1.1,2.6-1.5-1-2.6-1.6-2.2l-2.5,1.8c-.7.5-2.9.6-3.1,1.5l-.5,2.9-3.4,1.5c1.1-1.4.9-4.5-1.2-5.4s-3.6,3.2-2.6,4ZM234.5,275.7l214.6-18c1.4-.1,1.7-4.8.7-5.7l-128.6,11.2-110.4,10.1c8.1,1.3,15.1,3.2,23.7,2.5ZM210.9,262.6l8.3.4,2.7-4,1.9,3c.3.5,2.7.3,3.3.1s.2-2.2.1-2.8c1.6.9,4.7,2.4,6.5,2.5s1.7-2.1,1.1-2.8-1.8-1.7-2.2-1.3l-2.2,2.1c.3-1.6.3-4.9-.6-6.1-2.5,0-3.9,3-3.5,4.8-1.3,0-2.7.3-2.9-.3l-.8-3.2c-.2-.7-2-1-2.4-.4s-1.3,2.5-1.7,3l-3.9,4.1c0-1.5.5-2.8,0-3l-2.6-1.1,3.9-1.9c-.7-.7-4.5-.8-4.9.3-.5,1.7-.6,5.5-.2,6.6ZM311.9,261.7l-.7-5-43.1,3.7v5.1c-.1,0,43.8-3.7,43.8-3.7ZM519.9,266.1l-1-9c-6.9-.4-11.9-.4-18.5,0v9.2c7.6-.5,11.6-.6,19.5-.2ZM498.3,267.3l-.2-9.2-31.3,2.3v9s31.5-2.1,31.5-2.1ZM449.9,265.3c.2-2.8.2-3.9-.1-5.4l-193.8,16.4c7.3,1.5,14.9,3.5,23.2,2.8l170.8-13.8ZM464.9,269v-8.8c-.1,0-11.9.8-11.9.8v8.8c-.1,0,11.9-.8,11.9-.8ZM562.9,273.5v-8.6s-29.2-3.5-29.2-3.5c2.8,3.5,6.1,8.2,9.4,9.5,7,1.5,13.1,2,19.9,2.6ZM255.5,266.6c.9,0,1-4.6.3-4.9l-50,4.6c-1.3.1-1.2,5.1.2,5l49.5-4.7ZM526.9,268.8c-1.1-2.4-2.7-4.8-4.9-7.2-1.2,3.7-.4,7.6,4.9,7.2ZM576.8,273.6l-1.1-8.6-10.7-.2v8.5c.1,0,11.8.2,11.8.2ZM534.8,269.8l-2.6-2.9c-.4,2,1,3.4,2.6,2.9ZM379,441.9l40-.9,34-.9v-115c0,0-.3-31.2-.3-31.2,0-8.7-2.4-17.6-3.2-26.3l-171,13.8c-1,7.6-1.3,15-1.9,22.6s-1,11.1-.9,17.1l.4,103.8c0,6.3.4,11.8.7,18.2l35.3-.3,66.9-.9ZM503.2,302.3h13.6c.7-6.2,1-13.8-2.1-19.7s-1.3-2.8-1.2-3.7,1-1.5,1.6-2.1l2.5,8.5,3.3-16c-7.2-1.6-13.3-1.5-21.1-.3.7,5.9,1.6,10.2,3.1,15.2l2.6-7.7c2.8,3.4,5.8,7,4.5,12l-3.5-8.5c-4.2,7.7-3.6,15.2-3.2,22.5ZM501,303.2c.4-8.6-.3-16.3-1.8-23.9l-5.7-1.4-7.7,1.5c-1.9-1.6-2-5.6.2-7l2.1,6.2,1.9-6.2,2.7,3.4,1.6-3.6c1.5,2.4,1.9,3.2,4.1,5.5l-.4-8.8-30.6,2.4c-1.7.1,0,6,1.8,5.9l2.4-3.7,3,3,2.2-3.4,1.8,5,2.2-5.7,3.1,6.6-8.8.4c-2.2.1-4.4.6-7.1.9l.3,24.8,32.8-2.2ZM458.8,282.1c-3.6,7.6-4.4,14.8-3.3,22.8h10.7s0-15,0-15c0-6.6-.4-12-1.7-18.6l-12.3.5c.8,6.1,1.5,10.2,3.1,15.5l3.1-9.5,3.9,6.1c1.2,1.8,1.8,4.6,1.7,7.1l-5.1-8.9ZM534.9,285.2c.2-4.8-.3-7.1-3.4-10.8s-5.3-5.4-8.7-3.3c-3,10.6-4.5,21.3-3.8,32.6l15.2,1.7.7-20.2ZM541.6,276.5c-1.5-2.4-3.2-3.7-5.9-4.4.5,2.6,1.7,6.7,5.9,4.4ZM563.1,275.6l-17.4-1.5c6,7.1,10.6,11.4,17.2,17.1l.2-15.6ZM603.2,326.7c.7-7.8.6-14.2-.3-20.3l-23.3-32.9c-2.3,13.1-3.3,19.1-2.7,31.5l26.3,21.8ZM574.5,301.8c0-9.1,1.1-16.3,2.6-25.7l-12.2-.3.7,18.2,8.9,7.9ZM603.4,293.4c-5.3-6.5-10.3-12.1-16.5-17.3,4.9,9.4,10.5,17.1,16.6,25.3.5-2,1-6.5,0-7.9ZM222.3,280c0-2.6-3.2-3.8-4.6-3s-.9,3.3,0,3.9,4.6.4,4.6-.9ZM254.1,285c.3-3.9.1-5.9-.6-8.4l-12.6,1c-4.7.4-10.9.4-16,.2s-.8,3.8.5,3.9l28.7,3.2ZM261.4,284.6c.3-1.2.7-4.2-.1-4.4l-3.9-.7c-1.4-.3-1.7,3.7-.9,4.9s4.6,1.4,4.9.2ZM543.3,278.7c-.8,0-2.1.7-3.3,1.4l6.7,9.3c2.2-5.3-.7-10.6-3.4-10.6ZM275.6,285.5c2.7-5.7-8.2-4.8-11-5.2-.6,1-.4,4.6.3,4.6l10.7.6ZM214.6,288.8v-7c-6.3-1.4-11.6-1.6-18.3-.4v7.2c7-.9,11-.7,18.3.2ZM194.1,290v-8c0,0-26.2,2.2-26.2,2.2l.2,7.7,26-1.8ZM260.6,287.3l-29.2-2.7-14.5-1.7c-.2,3,0,5.4.9,7.6l43.4,4.1c1.2-1.6,1.2-6.7-.6-7.3ZM166.6,291.2l-.5-6.9c-2.8,0-6.8,0-8.6,1s-.9,5.3-.6,6.5l9.7-.5ZM547.1,306.6c.1-3.4.9-8.2-.4-10.2l-7.8-11.5c-.6,0-2.2,2.1-2.3,3l-.3,17.2,10.8,1.4ZM275.9,294.4l-.7-7.2c-4-.2-7.2-.2-10.9.1l-.3,6.4,11.9.7ZM554.3,294.9l-3.9-8.5c-1,2.1-1.4,4.2-1,5.7s2.4,2.2,4.8,2.8ZM199,320.8l12.8-.2c.2-4.6-.6-10.3.3-14.5l3-14.5c-7.6-1.5-12.4-1.6-19.9,0l2.8,11.4c1.3,5.3.7,11.9,1.1,17.8ZM195.7,305.3l-5.8.4,5.5-1.2-1.8-12.5-26.8,2.1,3.2,8.5.6,21.3,26.7-1.6c.3-4.8-.7-14.4-1.6-16.9ZM248,324.7l14.6,1-.6-29.3-44.6-4.2c-3.1,9.9-4.5,19.2-3.5,30.1l16.1,1.2.4-17.5c.1-4.3,4.3-7.7,8-7.6,12.8.1,8.6,18.1,9.6,26.3ZM159.4,308.2l.5,14.9h8.4c.3-10.4.2-19-2.3-29.2-3.5-.2-6.7-.1-9.8.2.7,5.2,1.4,8.1,2.7,11.7l2.1-6.4c2.1,4.2,3.4,7,3.6,11.4l-3.5-5.7c-.1-.4-1.9,2-1.9,3ZM562.6,300.4c1.3-4.5-.9-5.6-3.9-5.9.9,2.2,2.4,4.4,3.9,5.9ZM273.5,312.5l2.6-15.5c-4.5-.9-8-1-12-.4l.5,29,8.6-.4c0-4.4-.5-8.4.2-12.8ZM634.1,321.9l-12.3-5.4,2,6.5-8-10.3c-.3-.4-2.4-1.2-2.9-1.4s1.6-1.3,1.9-1.7l-8.8-13.8c-2.6,5.1-.3,9.5,4.1,12.4s2,3.4,2.8,4.7c3.2,5.3,7.3,9.6,11.6,14l-.5-4.2,9.6,13.9.4-14.7ZM135.9,380.9l22.2-22.7-.3-43.2c0-6.2-2-12.1-4.1-18.9l-15.4,28.3c-1.7,3.1-2.7,5.9-2.7,9.6l.3,46.9ZM246.2,324.5c-.6-7.7,2.1-24.4-7.7-24.1s-5.9,16.7-6.4,23.3l14.1.9ZM136.5,321c4.4-7.7,7.1-12,9.6-19.3l-11,13.9c.4,2.1.9,4.4,1.4,5.4ZM555.1,306.9l-4.6-5.3c-1.2-.1-1.9,3.6-1.2,4.8s2.7.9,5.8.5ZM517.2,312.8v-8.2c-.1,0-14.3,0-14.3,0v8.3c-.1,0,14.3-.1,14.3-.1ZM574.9,308.1c-4.7-2.6-5.6-2.8-10-4.5l1.1,5.5c3.6,0,5.3.2,8.9-1ZM626.2,315.7c-4.4-4.9-7.6-8.1-12.6-12-.2,3,7.8,14.6,12.6,12ZM500.8,314.2v-8.6s-32.6,1.8-32.6,1.8c-.4,2.8-.4,5.9,0,8.4l32.5-1.6ZM546.9,316.9c.8-2.8.9-6.4-.6-8.4l-26.9-2.5c-.4,3-.3,6.5.7,8.7l26.8,2.2ZM466.3,315.5l-.4-8.2h-10.7s-.2,8.3-.2,8.3h11.2ZM563.5,318.6l-5.2-8.2-8.9-1.1v8c0,0,14.1,1.3,14.1,1.3ZM575.4,310.6l-8.6.9,7.8,9.7.8-10.7ZM633.1,349.6c2.4-3.7.3-6.7-2.1-9.4l-25.8-29.8v18.3c-.1,0,27.9,20.9,27.9,20.9ZM585.4,325.1l-7.7-13c-.4,4.7-.3,7.6,0,12.1l7.6,1ZM594.7,343.3l-2.6-8.6,11,17c1-7.3.4-12.7,0-19.7l-7-2.5,2.7-1.3-16.7-14.1c.7,3.9,5.1,13.5,8.7,13.4l-1.3,1.9,2.7,5.8-5.4-7.1c-1.1-1.5-5.2-2.1-8.2-1.8,5.2,6.4,9.7,11.2,16.3,17ZM517.2,354.9v-39.3c-6.5,0-14.3-2.9-14.3,3.5v35.8c0,0,14.3,0,14.3,0ZM500.9,356.3v-39.7c0,0-32.7,1.6-32.7,1.6-.2,2.9-.3,5.2-.3,7.9v31.6c.1,0,33-1.4,33-1.4ZM525.9,356.1l8.2.2v-23.4c.1,0-.3-14.9-.3-14.9l-14.5-1.3c-.2,15.5-.9,23.4,1.3,38.4,2.3-8.3-2.7-14.4.4-22.2s2.5-2.7,3.4-2.4,2.4,1.4,2.8,2.1c4.8,7.3-3.4,10.8-1.4,23.5ZM466.1,357.1v-38.9c-4-.2-7.8-.2-11.1,0v38.8s11.1,0,11.1,0ZM538.1,326.4l-.3-2.4c0-.6,1.6-1.5,2.2-1.4l5.2.3c.8,0,2.3-.8,2.8-1.4s-1.4-2.6-2.2-2.7l-10.6-.6.4,9.7,10.8.7c.7,0,1.1-2.7.5-3l-2.2-.9c-2.4-1-4.1-.4-6.7,1.6ZM552.4,327l1.6-7.3-5.1-.2c-.6,0-.2,3.4.4,3.4l2.4-.2.7,4.4ZM128.8,329c4.5-1.1,6.2-4.6,4-8.6l-4,8.6ZM557.4,339.6c0-3.9,3.2-6.3,6.5-5v-13.5c-3.1-.3-6.4-.3-8.2,0-.9,4.6-2,7.1-4.8,9.7v26.2c1.6.7,4.8.9,6.5.3v-17.9ZM575.1,357.5l-.2-28.3-8.8-8.8.2,37.3,8.8-.2ZM212.1,330l-.9-7h-11.7c-.7,2.1-.7,6.1,0,7.1h12.7ZM170.9,333.2l25.3-1.8c.8-2,.7-5.3,0-7.1l-25.3,1.6c-.5,2.6-.5,5.1,0,7.3ZM262.4,334.8c.2-3.2.1-5.3-.3-7.1l-47.3-3.1c-1.2,1.8-1.1,5.7.3,7.1l47.4,3.1ZM549.5,330.1c.3-2,.2-3.7,0-5.1-.3,2-.2,3.7,0,5.1ZM168.8,332.7l-.5-7h-8.4s-.1,6.7-.1,6.7l9,.4ZM646.3,341.4l-10-16.1c-.6,5.7-.8,9.8,0,14.3,1.9,2.3,7.5,3.4,9.9,1.7ZM119.7,335.7c5.6-.5,6.8-4.7,6.9-8.5-2.8,2.9-5.2,5.7-6.9,8.5ZM273.6,334.5l-.3-6.8h-8.4s0,6.6,0,6.6l8.9.2ZM547.7,357.4v-26.2s-11.4-1.4-11.4-1.4v26.9c-.1,0,11.4.8,11.4.8ZM660.2,344.3c-6.4-5.8-11.6-10.1-18.4-14.6,2.9,9,8.8,17.8,18.4,14.6ZM113,400.6l21.1-17.8-.3-50.5-21.4,32.3c-.8,4,.4,9.9.4,14.2l.2,21.8ZM212.3,367.6l-.4-34.8c-4.3-.3-8.6-.3-13.2,0l.4,35.1,13.2-.4ZM523.7,343.3c4.1-3.2,3.8-8.1.3-11.1-2.9,3.5-3.1,8.2-.3,11.1ZM603.2,412.5l-.2-41.4v-12.8c.1,0-25.2-25.7-25.2-25.7l.4,107.7h25.3s-.3-27.7-.3-27.7ZM124.2,340c1.8-2,3-3.8,4-5.9-2.5,1.3-3.9,3.3-4,5.9ZM197.1,369l-.5-35.1-26.1,1.7v34.3s26.6-.9,26.6-.9ZM247.1,370.4v-26.8s-14.4-1-14.4-1l1.9-2.1,14.5,1.7-.2,28.4,14.1.3-.2-34-48.6-3.1c-.2,6.8-.6,31.9,1.1,35.4s2.2-.5,2.2-1l.5-16.6c2.5,6.2,1,11.6,1.6,17.6l10.6.2v-30.7c.4.2,1.9,1.8,1.9,2.6v28.3c.1,0,15.1.7,15.1.7ZM168.6,368v-32.6s-8.7-.7-8.7-.7v13.3s-.2,21-.2,21c3.4.6,7,.9,9-.9ZM562,345.7c2.9-2,3.1-7-.3-9.8-1.2,1.6-2.3,4-2.7,5.5s1.6,4.2,3,4.3ZM622.9,354.8l8.7-1.4-23.8-17.5c2.5,6.5,5.9,11.6,9.4,17s4.2,2.2,5.7,2ZM273.8,355.7l-.4-18.7c-3.1-.4-6.7-.3-8.6.6l.2,32.8,8.5.4c.3-4.9.4-9.6.2-15.1ZM616.4,354l-10.8-17.7-.3,18.5c4,0,6.7,0,11-.8ZM113.5,355.4c3.4-5.7,5.9-11,8.4-17.2-3,1.4-7.6,3.3-8.7,5.9s-.6,7.5.3,11.3ZM665.1,347.6l-14.1-2.5,3.1,7.1-5.5-7c-1.5-1.9-6.4-2.6-8.9-1.5,6,6.9,11.5,12.4,18.1,17l-3.8-9.1,10.7,15,.3-19.1ZM522.1,344.8l.4,12.1c2.5,1.4,1.9-14.3-.4-12.1ZM651.1,361.4c-5.2-6.7-10.3-11.4-15.7-16.6-.4,2.1-.5,6,.8,7.1,4.3,3.7,9.6,7.6,14.9,9.5ZM564.3,358.1l-.2-9.2c0-1.2-4.6-2-4.6-.8l-.3,9.9,5.1.2ZM110.3,360.2c.9-3.9.8-7.9-.2-12l-6.5,14.4c1.9,0,6-1,6.8-2.4ZM695.4,369.6l-24.6-18c1.2,3.7,2.2,5.6,3.7,8.7l-7.4-9.9c-.8,7.3-.6,12.4,0,19.2l11.5.6c.3,0,1.1-1,1.1-1.3l-.4-1.7c2.6,4.6,10.4,3.4,16.1,2.4ZM101.1,364.6c2.1-4.7,3.5-7.8,4.7-12.4-5.5,5.1-9.2,9.1-13.9,14.6l9.2-2.2ZM626.5,374.2l-1.3-6.5c2.9,4.3,4.5,7.9,8.7,12.2v-24.9c-5.4.1-9.9.5-14.7,1.3l5.8,11.8-7.5-11.8c-2.9-.1-6.3.1-9.5.8l18.5,17.1ZM517.3,366.3l-.2-9-14.1.3v8.8c.1,0,14.4,0,14.4,0ZM547.7,369.3v-9.6c0,0-28.3-1.8-28.3-1.8v9.6c0,0,28.3,1.8,28.3,1.8ZM651.3,380.2l13.4-4.8-24.6-16.2c.5,2.9.9,3.9,1.7,6.7l-5.8-8.1v25.2c5.1,0,9.1-1.1,12.9-3.3l-6.9-14,9.3,14.5ZM500.7,367.5v-9.2c.1,0-32.8,1.3-32.8,1.3v9c0,0,32.8-1.1,32.8-1.1ZM466.3,368.2l-.2-8.7h-11.1c0,0,0,8.6,0,8.6h11.2ZM564.2,370l-.2-9.6-14.3-.7v9.5s14.5.7,14.5.7ZM575.2,369.4l-.3-9.2h-8.4c0,.1-.2,9.1-.2,9.1h8.9ZM634.1,440l-.2-54.2-28.5-24.4-.3,52.6.3,26.2,28.6-.2ZM98.1,376.1c3.9-3.9,6.3-7.1,9.6-11.8-5.7-1.5-8.8,6.1-9.6,11.8ZM157.3,385.2c0-8.2.4-12.9-.6-20l-9.1,20.1c3.5.2,6.4.2,9.7,0ZM89.6,386.7l9.9-19.8-10.9,2.9,1,16.9ZM111.1,401.8v-21.8c0-4.4,0-8.4-.4-13l-21.9,27,.4,23.7c8.5-5.3,15-10.1,21.9-15.8ZM517,403.5v-34.6c-4.8-.3-9.2-.3-14,.1v71s14.3-.2,14.3-.2l-.3-36.3ZM212.6,377.5c0-2.3-.4-5.4-.9-7.2l-12.5-.4-.2,7.9,13.6-.2ZM468,419.3l32.9-.2v-49.4s-33,1.2-33,1.2v8.2s.1,40.2.1,40.2ZM547.8,386.3l-.2-15-28.7-1.6.2,46.5,4.2-8.8c1.6-13.1,9.9-23.6,24.5-21.1ZM196.8,378.9v-7.9c-.1,0-26,.9-26,.9-.4,2.8-.4,5.4-.1,7.9l26.1-.8ZM262.6,380.5c.6-3.1.5-5.9-.5-7.4l-47.1-1.8v7.5s47.6,1.6,47.6,1.6ZM466.2,440.1v-19.1c0,0-.2-50-.2-50-3.7-.6-7.1-.6-10.9-.2v35.2c0,0,.5,34.1.5,34.1h10.6ZM146.1,385.1c2.2-4.9,4-8.5,5-13.6l-14.6,13.8c3.3.6,6.9.8,9.6-.1ZM168.7,379.2l-.4-7.5h-8.5c0-.1.2,7.5.2,7.5h8.7ZM564,406.4l.3-34.3-14.7-.7.2,15.4c3.5,2,7.8,4.3,9.3,7.8l5,11.8ZM573.8,440.8c1.6-4.9,1.3-8.5,1.5-12.8l-.2-55.7c-3-.7-6.2-.7-8.6.3.1,11-.4,21,.7,31.4.5,4.9,5.6,9,4.1,14.8s.8,5.8,1.1,8.3l1.4,13.7ZM671.9,372.3c5.5,4.9,10.9,9.2,17.2,12.6-4.3-10-7.4-15.6-17.2-12.6ZM698,386.9v-15.2s-14.8.5-14.8.5c.7,1.9,14.8,24.9,14.8,14.7ZM87.5,390.6l-.8-17.9-8.8,18.4,9.6-.5ZM273.8,380.1l-.2-7-8.3-.2v7c-.1,0,8.5.1,8.5.1ZM730.8,406l-.6-14.1h-10.3c0-.1,8.5-2.2,8.5-2.2l-23.5-14.2v3.4s-5.5-6.1-5.5-6.1l-.4,15.3c0,1.6,2.5,4.4,4,4.2l9.8-.7-1.4-4c2.7,2.1,5,3.8,7.3,5.1-.3.1-1.6,1-1.3,1.4l1.4,2c3.2,4.7,6.3,9.2,12.1,9.8ZM76.1,391c2.6-5.2,4.5-9,6.1-14.4l-15.7,14.2c3.3.8,7,1,9.6.3ZM658.2,399c1.1-.8,2.4-1.8,2.3-1.7l4.4,4.8v-24.6c-5.8.8-9.3,1.9-13.1,3.8l4.2,8.9-5.6-7.9c-3.6-.9-8.2.2-10.9,3.2l18.7,13.5ZM697.8,418l.2-20.2-4.1-1.4,3.3-1.7-24.4-14.9c-.5-.3-1.8-.9-2.1-.5l-1.3,1.3-2.7-2.8.2,25.1c.2,1.4,4.9,1.7,5.7,1.3l-1.5,2.3,21,9.8v-3c0,0,5.5,4.7,5.5,4.7ZM213.1,443.1l-.7-62.9c-4.8-.4-8.8-.3-13.4.1v63.1c0,0,14.1-.3,14.1-.3ZM175.9,443.6l21,.2v-17.1c-6.4.5-11.4.7-17.1-.3l16.7-.7v-11.6c0,0-6.7-.5-6.7-.5l7.1-1.1v-31.4s-26.8.8-26.8.8v61.4c1.5.2,2.8.5,2.9,0l.2-2.3.4-3.7,4.6-6.1c2.3-3,5.9-3.9,8.9-1.2l5.8,5.2c-.4.2-2,1-2.3.5l-1.2-1.4c-1.3-1.5-3.9-4.2-6.5-4.4s-10.6,9.9-7,13.6ZM227.3,399.7c9.3-3.7,18.1-2.6,24.1,4.9s5.6,11.7,5.7,18.4v8.3c.1,0,.2,11.6.2,11.6,1.3.7,5.2.4,5.8-.8v-30c0,0,0-13.5,0-13.5-2.4.5-3.9.8-5.2,1-3.1.4-4.2-10.2.5-15.2,1.3.4,3,1.9,4.4,3.3.6.5.6-5.1-1-5.1l-46.6-1.6c-.7,3.3-.7,6.8-.1,9.2,2.2-3.3,3.5-5.2,6.1-7.5,3.3,4.4,4.3,9.4,2.1,14.1s-5.9,1.5-8.4-.5c-.2,6.2-.1,12.4.1,18.8.4,9.8-.9,18.9,1.2,28.9,4.2-16.3-7.4-44.4,17.2-49.4,11.6-2.4,22.2,3.8,25.5,15.4s3.1,17.7,1.3,26.6c-2.9-10.9,1.5-19.2-4.8-30.5-5.6-10.2-19.3-13.8-28-6.3ZM168.1,434.4v-45.4s0-7,0-7c-3.1-.6-6.4-.6-8.5.6l.4,61h8.3c0,0-.3-9.1-.3-9.1ZM274.2,442.7l-.4-60.3h-8.5s-.2,18.5-.2,18.5v42s9.1-.3,9.1-.3ZM221.2,385.7c-3.4,1.3-3.8,6.8-3.2,9.2s1.8,1.5,2.5,1.6c2.6.3,2.7-8.1.7-10.8ZM144.6,387.6l-9.1-.4.6,17.9,8.5-17.5ZM154.9,387.2h-8.6c-2.6,5.4-4.6,9.5-6.1,14.9l14.7-14.9ZM259.6,387c-1.9,2.3-3,6.5-2.1,9.3s2.5,2.2,3,1.7c3.1-3,2.3-7.7-.9-10.9ZM548.1,389.7c-2.1-1.4-4.3-1.9-7.2-1.4,2.1,1.3,4.3,1.8,7.2,1.4ZM665,439.8v-32.6s-29.1-19.6-29.1-19.6v52.5s29.1-.4,29.1-.4ZM560.6,411c2.3-5.5-3.7-22.6-11.5-21.3,3.9,4.3,7.7,7.3,9,12l2.5,9.2ZM133.7,409.5l-.7-20.2-10.6,18.2,11.3,2ZM135.9,444.1l21.7-.3-.6-53.3-19,18.7c-1.4,1.4-2.4,3.6-2.4,5.6l.3,29.3ZM534.6,428.6l.4,11.3h13s-.3-47.4-.3-47.4c-4.5-1-8.2-1.1-12.2,0s-8.8,6.6-8.6,10.9c6.1.3,6.9,10.4,7.1,14.5l.6,10.6ZM74.9,393.5l-10.1-.8c0,7-.1,11.5.8,17.9l9.3-17.1ZM83.6,393.3c-2.3-.5-5.8-.6-6.8.4-1.9,3-3.9,7.2-4.8,11.4,4.6-4,7.8-7.4,11.7-11.8ZM714.8,393.7c-2-1.4-5.9-.8-8.7.4,4.8,3.4,8.6,5.4,13.8,7.3-1-3.1-2.5-5.8-5.1-7.7ZM760.4,406.6l-16.4-8.6c-.7-.4-2.5-1.2-3-.8l-1.9,1.3-7-6.2-.3,14.4c5.2,2.4,9.7,4.4,15.8,1.7l-6.6-8.3c6.8,5,6.1,11,19.4,6.4ZM120.8,406.8c2.9-4.6,5.1-8.5,6.7-12.9-6,4-10.2,7.4-14.9,11.7,2.5,1.4,6.9,2.5,8.2,1.2ZM561.7,417.8l-3.6-2.7c-.2-7.6-1.2-18.4-8.5-21.3l.2,46.1h11.7c0-.1.2-22.2.2-22.2ZM63.3,413.4l-.5-18.9c-4.5,5.9-6.6,10.8-10,17.8,4,.7,6.7,1,10.6,1.1ZM65.2,431.4l21.8-11.9v-23.9c0,0-21.9,20.7-21.9,20.7v15ZM717,413.4c3.6,1.7,7.5-.2,10.3-2.2l-20.2-9.8,1.6,4.7-9-8.9.2,22.4c6.7-1.5,9.6-2.5,15.7-4.7l-4.8-6.1c-.9-1.4-1.2-2.3.4-.6,1.6,1.7,3.7,4.3,5.7,5.3ZM51.3,411.5c2.4-4.3,4.2-7.8,5.8-12.5l-14.9,11.4c3.3,1.1,6.4,1.6,9.1,1.2ZM223.7,443.5h31.5c0-10.1.7-18.7-.7-27.8s-9.6-17.4-19.8-15.9-13.6,5.6-13.2,10.9,2.4,9.6,2.3,14.2v18.6ZM119.7,409.1c-4.3-.7-5.3-.8-7.4-1l.9,12.3,6.5-11.4ZM763.7,418.6l.2-10.7c-4.9.1-7.7.5-12.6,1.9,3.5,4.8,6.1,6.8,12.3,8.8ZM107.1,425.9c1.3.4,2.9-2.8,2.8-4.1l-.9-13.5-10.4,15.1,8.5,2.4ZM531.6,425.5c1.1-5.4.7-11.2-2-16.3-3.8,3.3-5.7,10-3.6,14.8s3.8,1.7,5.6,1.6ZM697.9,439.9v-17.4c-.1,0-31-13.9-31-13.9v31.5s31-.2,31-.2ZM129.9,411.3c-3.3-1-5.8-1.4-8.9-1.8l-5.7,11.7c6.2-3.1,9.8-5.7,14.6-9.9ZM569.3,425.1c.3-5.6.1-10.4-2.3-15.2-3.4,4.5-3.9,9.5-3,15.1h5.3ZM752,414.5c-.8-6-5.3-5.4-8.4-3.1l8.4,3.1ZM779.2,419.5c-4.1-3.7-7.4-6.3-12.7-10.3-.9,2.9-1.1,7-.4,9.4,3.8,2.7,8.4,3.3,13.1.9ZM49.8,413.8c-4.5-.9-6.6-1.2-10.2-1.5l1,15.4c4.2-5.1,6.1-8.2,9.2-13.9ZM97.1,422.6c2.7-2.4,5.3-6.5,6.9-10.1l-14.1,9c1.5.7,6.1,2.2,7.2,1.1ZM731.1,427.3l.2-14.7-11.9,3c4,5.1,6.5,8,11.7,11.6ZM789.2,418.1l-14.1-5.3c2.6,6,8.5,8.8,14.1,5.3ZM59.4,415.5l-8-1.5-5.3,10.2c5.6-2.6,8.9-4.8,13.3-8.8ZM112.8,445.6c4.1,0,7.1,0,10.1-.3l11.2-1.4-.3-29.6c-1.9.9-3.7,2-5.4,3.1l-15.8,10.2.2,18.1ZM749.4,424c-5.7-4.4-9.3-6.9-16-10.8l-.3,14.8c6.2-1.1,10.2-2,16.3-3.9ZM38.7,429.7l-.9-15.1-9.9,12.9,10.8,2.3ZM220.1,443.8c1.9-9.7,2.9-18.5.3-28.3-1.7.7-2,26.9-.3,28.3ZM725.7,425.9c-3.4-4.7-5.5-6.7-8.9-10.2l-12.4,4.4c7.7,3.1,12.8,4.5,21.3,5.9ZM522.9,426l-.4-8.5h-3.2c-.6.1,0,2.7.2,3.1l3.3,5.3ZM26.8,426.3c2.4-2.4,4.5-5.6,5.7-8.4-4.7,2.3-7.9,4.3-12,7.1,1.4,1.1,5.2,2.5,6.3,1.3ZM47.1,442.6c-1.3-.1,0-4.4,1.3-4.9l14.9-5.6v-14.1s-22.4,13.9-22.4,13.9c-.4,1.4-.5,4.3-.4,6.1l.4,9.1,19.9-.4c.9,0,2.6-1.5,2.7-2.2.3-1.7-10.8-1.4-16.4-2ZM757.5,421.6l-10.3-2.8c1.6,4.6,6.2,6,10.3,2.8ZM493.4,439.8c1-1.4,2.7-3.8,2.4-3.3,1.6,2.6,2.5,4.1,5.3,3.5l-.4-19.4-32.6.2-.2,18c0,.8,2.6,1.6,3,1.1l1.8-2.4c.6.6,2.7,2.6,3.6,2.6l17.1-.3ZM785,424.1c-1.6-2.9-4.5-3.9-7.2-2.3,2.4,1.2,4.7,1.9,7.2,2.3ZM96,425l-7.2-1.8.3,10.2,6.9-8.4ZM757.8,430.8l-.8-2.8,7.3,2.8c.9-2.5,1-6.2-.2-7.7l-9.3,1.6,2.4,3.4c-6-3.6-9.1-3.4-15.5.8l16.2,1.8ZM731.4,439.9l-.3-8.4-31.3-8.1v16.6c0,0,31.6-.2,31.6-.2ZM788.7,429.9l-22-6.5c-.8,2.6-.7,6.3,1.1,7.8,7.2,0,14,.7,21-1.3ZM86.7,435.4l-.7-11.3-9.8,9.7,10.5,1.6ZM105.4,427.5l-7.4-2.5c-2.3,2.4-3.6,4.3-4.8,7.5l12.2-5ZM25.4,428.8l-8.4-2,.7,9.9,7.7-7.9ZM532.7,439.6v-11.7s-6.7,0-6.7,0v11.9s6.7-.2,6.7-.2ZM570.7,440.1v-12.4s-6.9,0-6.9,0v12.2c0,0,6.9.1,6.9.1ZM33.5,431.3c-2.8-2.2-5.5-2.9-7.3-1.7s-2.4,2.9-3.5,5.7l10.8-4ZM77.5,429l-6.7,3.1c2.5,2.3,5.6,1.4,6.7-3.1ZM109.6,445.9l-.6-16-19.8,7.7c-.5,2.1-.5,5.5-.4,8.4h20.8ZM764,439.7c1.5,0,.5-4.7-.7-4.8l-30.2-3,.4,8.2,30.5-.3ZM39,447v-14.2c0,0-21.4,7.8-21.4,7.8-.6,1.9-.6,5.2,0,6.7l21.4-.2ZM72.4,435.1c-3.5-.6-4.6-.7-5.7-.8s-1.4,4.5-.4,4.5c1.9,0,4.6-1.7,6.1-3.8ZM80.3,436.6c-1.6-.6-3.2-1.1-4.7-1.4s-2,1.4-2.9,3l7.6-1.6ZM62.7,440.4l.5-4.9-6.7,3.3,6.2,1.6ZM87,446l-.5-7.3-19.2,4.1c-.9.2-2.1,1.2-2.5,1.7s1.7,1.9,2.4,1.9l19.9-.4ZM562.6,458.2h-20.7c0,0,0,44.8,0,44.8-.5-.2-1.9-1.6-1.9-2.3l-.2-48.3-8.8.3c-10.1.4-19.9.4-29.9-.2l-13.1-.8c-4.7-.3-9.4.7-13.9.8-14.4.6-33.2.8-46-1.6l111.4-.2v-8.3s-37.5,0-37.5,0l-76.6.4v37.9c14.1-7.7,22.9-13.4,37.6-7.9l24.1,9c4,1.5,8.3,3.2,11.2,6.2-15.7-5.1-29.3-13.4-45.6-15.5-8.1-1-17.1,5-23.8,8.9-8.8,5.1-12.5,15.6-9.3,25.1,9.6,2.3,20,3.2,29.8,3.2h24.7s94.9-3.5,94.9-3.5l45.1-2.4v-44.9c0,0-51.4-.8-51.4-.8ZM422.3,449.6c.3-2.7.3-4.3,0-6l-66.3.6-19.1.4c-.7,1.2-.5,4.2.3,5.8l85.2-.7ZM299,450.9l33.8-.8c1-1,.8-5.6-.6-5.6l-44,.7-52,.9v5.8s62.8-1.1,62.8-1.1ZM134.7,453.1h98.2c.9-2.4.8-4.6,0-7.2l-105.2.6-.7,6.7h7.6ZM407.4,452.8l-11.1-.5.7,12.2,10.4-11.7ZM422.1,457.2c.6-.9.9-3.8.8-5.1l-10.1.5.6,16.5,8.7-11.8ZM302.3,461.5l.4-8.1-8.3.7,7.9,7.5ZM314.2,458.8c-3.4-2.7-5.2-3.9-9.3-5.8l-.3,8,9.6-2.2ZM333.7,455.4c-1-1.5-1.7-2.4-2.2-2.9l-21.7.6c7.3,8.6,11.7,3.7,23.9,2.3ZM363.2,458.4l-.4-5.8-25.1.2c-.4,0-.9,2.6-.5,2.6l1.9.2,24.2,2.7ZM371.4,453.1l-6.6-.5.9,5.8,5.7-5.3ZM379,461.6l-.4-8.6c-.5-.3-3.7-.4-4.4.3l-6.9,5.9,11.7,2.4ZM390.3,452.9l-10.1-.3.9,8.9,9.2-8.6ZM395.1,465.5l-.8-13.4-11.6,10.2,12.4,3.2ZM411.2,469.8l-.3-16.5c-1.3.8-2.8,1.7-3.3,2.3l-8.9,10.6,12.5,3.6ZM255.4,473l.2-18.7c-4.5,0-7.5,0-12.1.5l11.9,18.1ZM271.5,453.9l-11.1.6,10.7,14.2.4-14.8ZM287.5,453.7l-10.3.5,9.7,10.5c.7-4.2.9-7.2.6-11ZM300.1,461.4l-10.3-8.2-.4,11.2,10.7-3ZM195,505.6l38.8-1.4.2-21.2v-28.1s-7,0-7,0h-92.8s-7-.2-7-.2l-.2,22.9c9.2-4.2,13.5-7.4,23.4-5.3,11.8,4.9,23.7,8.2,35.2,14.9l-38.9-13.7c-7.6-2.7-36.1,13.1-28.7,30.3,22.9,3.9,53.4,2.5,77,1.7ZM240.2,476.7v-18.7c0-1.2-.3-2.5-.4-3.3s-3.7.3-3.7,1.2v23.8c1.7,1.3,4.1-.8,4.1-3ZM269.5,469.4l-11.5-15c-.6,7-.6,11.1-.5,18.7l11.9-3.8ZM285.2,465.2l-11.5-11.4-.5,14.8,12-3.4ZM253.9,474.4l-12-17.3-.2,21.7,12.2-4.4ZM275.3,479.4c23.9-7.5,45.9-16.4,70-19.7-7.3-2.5-13.7-1.5-20.8-.3-27.3,5.1-53.9,11.2-79.7,21.1,9.9-1.1,20.6,1.9,30.4-1.2ZM423.4,473.8l-.6-14.2-8.6,11,9.1,3.2ZM302.6,499.9c2.2-19.5-5.5-13.4-6.8-25l-18.6,7v20c0,0,25.5-2,25.5-2ZM275.2,485c0-1.1-1.6-2.5-3.1-2.5l-36.4,1v20.7c-.1,0,39.6-2.1,39.6-2.1v-17Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M282.2,251.1c1.5-.5,2.9-1.3,3.9-2.1l-1.5,4.5-1.9.3c-.5,0-.4-1.6-.5-2.6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M290,254c.2-2.3,1.5-4.2,4.1-5.2,0,3.1-1.7,3.8-4.1,5.2Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M498.8,466.2l6.4,1.5c-3.1,1.2-6.4,1.1-10.4.7l1.8-2.9c.5-.8-.8-3.5-1.8-3.5h-14.5c-.6.1-2.6-1.3-3.4-1.9l25.1.2c2.8,0,4.9-.6,7.8,1.1l-11,.8v4Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M449.9,475c-9.2,7.6-12.6,16.4-15.1,27.8-1.7-11.4,5.6-20.9,13.4-28.2l1.7.4Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M501.5,470.3l1.2.7c.4.2,1,1.3.6,1.5s-2,1.1-2,.6l.2-2.7Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M194.1,469.1l-5.2,3.1c-1.8-1-4.5-1.9-6.8-2h-1.5c-.3,0-.5-1.4-.2-1.4l2.1-.2.7-2.4c.2-.9-2.1-2.5-3.1-2.5h-11.2c0,.1,2.1-1.8,2.1-1.8l25.8.4c-4.2,3.4-8,.6-13.2,1.8l.4,4.3,10.1.6Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M129.4,499c-4.8-2.1,8.2-23.4,13.8-23.4l-4.6,5c-5,5.4-7.7,11.4-9.2,18.4Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M191.9,475.8h-7c2.1-1.5,4.4-1.7,7,0Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M258.8,369.7c-3.8-3.3-1.1-6.6-1.3-10,0-2.5.2-4.7,1.3-7v17Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M211.4,156.7c-.7,1.4-1.8,2.9-1.8,2.5l-.3-2.3c0-.5,2.1-.5,2.1-.2Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "186.9 396.5 187.1 411.1 179.9 410.9 180.6 392.8 181.6 396.4 186.9 396.5"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "187.8 416.1 188.5 423.8 179.6 423.7 181 416.3 182.4 422.3 183.3 416.8 187.8 416.1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M194.7,419.1v4.1c.2.9-2.7.5-4.2.4l.6-6.5c0-.6,2.1-1.7,2.4-1.3s1.1,2.2,1.2,3.2Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M174.6,392.9c2.9-1.2,2.7,11.7.9,10.4s-1.6-1.1-1.6-1.5l.7-8.9Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M193.8,401.4c-.4.4-3,0-3.2-.6-.3-1.8.4-5.9,1.8-7.5,1.6,2.2,1.9,5.9,1.4,8.1Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M193.8,407.8l-.4,2.8c0,.6-2.6.5-2.6,0l-.3-2.7c0-.5,0-2.4.6-2.4h2.2c.5,0,.6,1.7.5,2.3Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M176,417.4c.6,1.6.8,5.5.3,6.8-3.4-.6-3.3-6-.3-6.8Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M175.1,411.7c-1.5.1-1.6-5.5,0-5.7,2.4-.3,3,5.4,0,5.7Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M183.2,387.7c0-.4,1.6.5,1.5.8l-.6,1.6c-.1.4-1.5,0-1.4-.3l.5-2.1Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M187.9,393.7c-.5.2-3.5,0-3.9-.4-.2-2,3.3-1.6,3.9.4Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M188.1,413.5c-2.1.5-4.5.5-7.2,0,2.1-.5,4.5-.5,7.2,0Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M487.9,400.4h-7.4c0-.1.2-13.2.2-13.2,2.8,1,3.9.9,6.7-.1l.4,13.3Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M487.5,408.4v7.5c-1.6.5-5.2.4-6.7-.3-.6-3.3-.6-5.8,1.2-9.2l1.7,6.1c.5,0,1.3,0,1.4-.3l.2-2.3.3-2.4c0-.4,1.9.5,1.9.9Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M472.1,415.4l-.5-7.1,4.2-.8.9,7.1c0,.6-.9,1.8-1.3,2.2s-3.2-.5-3.3-1.5Z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "496.5 415.4 492.7 415.9 492.7 407.1 496.5 407.1 496.5 415.4"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M475.4,391.4h-2.6c-.7.2-1.4-8.8,1.4-8.4,1.7,2.4,1.6,5.9,1.2,8.4Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M476,397.9l-1,5c-2.2-.3-2.6-2.7-2.4-4.7l.2-2.3c0-.5,1.4-.7,1.9-.7s1.4,2,1.3,2.7Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M496.2,390.2l-1.7,1.2c-.4.3-1.8-1-1.8-1.4v-5.7c.1-.7,2.5-.5,2.8-.4l.8,6.4Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M496.1,397.9l-.6,2.8c-.1.6-2.4.3-2.5-.2l-.6-2.5c.1-1.1,0-2.4.5-2.4l2.6-.2c.6,0,.6,2,.5,2.5Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M487.8,384.4c.5,1.3-10.2,0-5.4-2.4l5.4,2.4Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M483.6,376.7c.4-.2,1.3.4,1.2.8l-.8,1.7c-.2.4-1.1-.1-1.4-.5s.5-1.8,1-2Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M488.1,403.5c-2.5.5-5.1.5-8.2,0,2.5-.5,5.1-.5,8.2,0Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M489.5,415.1c-.5-2.5-.5-5.1,0-8.2.5,2.5.5,5.1,0,8.2Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M490.5,402.1c-.4-1.8-.4-3.8,0-6.2.4,1.8.4,3.8,0,6.2Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M493.5,402.4c.2-.3,1.4-.6,1.8-.4.5.2.4,1.5.3,2.1s-2.4-1.3-2.1-1.7Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M182.6,226.3l1.3-1.1c.3-.2,1.1,0,1.1.4l.3,2.3,2.1-4.2.2,6.9-12,1.3.8-18c2.2-2,6.8-2.7,9.6-1.2l1.1,9.8c-3.5.6-6.3.8-9.3.8l1.6,3.4,1.3-1.6c.3-.3,1.2.5,1.9.9ZM184.4,217.3l-.5-2.8c0-.3,0-.2-1.7,0l1.2,6.5c.9-.8,1.4-1.2,1.4-1.5l-.4-2.2ZM180.1,215.3c-.8-.7-2.4.5-1.9,1.5l1.5,4.3.4-5.9Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M162.7,237.8c-.8-6.2-.7-10.5-.6-17.1l2.2,1.7c-.6,6.1.6,9.5-1.6,15.3Z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "488.4 354.3 481.2 354.5 480.9 339.6 488.2 338.9 488.4 354.3"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M476.6,352.6c0,.9-1.4,2.8-2.1,2.7s-2-1.6-2-2.4v-12.6s3.7-.6,3.7-.6l.4,12.8Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M496.8,351c0,.6-.6,2-.9,2.5s-3.1,0-3.1-.7v-12.6c0-.9,3.3-1.2,3.7-.8l.3,11.7Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M484.1,334.3c-.3,0-1.9,0-1.4,0l.3-6.5h1.8c0,0-.7,6.5-.7,6.5Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M552.5,240c1.7-5.6.6-11.6,1-18.4.5-1.6.9-1.8,1.7.3v16.6c0,.8,2.4,2.2,3.2,2.5l.4,9.1-32-3.3-.2-9.2c1.7-1.5,2-2.2,2-3.8l-.4-18.1,1.4,5.1.5-3.5c0-.5.2-.5,1.6-1l-.2,19.2c0,.7,1.5,2.6,2,2.3s1.4-1.5,1.4-2.2v-18.6c.1,0,15.9,2.7,15.9,2.7.4,6.7-.4,12.5,1.7,20ZM538.1,223.1c1.1-.9,1-4,0-4.2-1.5.4-1.4,4,0,4.2ZM542.6,239l.9-17.7c0-.7,0-1.9-.5-2.1s-2-.2-1.9.3l.3,2.4c1.5,13.7-2.6,14,1.2,17.1ZM547.1,239.7c1.3-6.7,1-12.7.7-18.7-2.2-1.8-1.9,0-1.4,1.8-.2,5.8-1.3,11.2.7,16.9ZM539.2,226.5c.2-4-5.2-1.4-.6,11.6l.6-11.6ZM556.6,247.9v-5c0,0-16.4-2.5-16.4-2.5-4-.6-7.8-.7-12.3-.7l.9,5.3,14.1,1.4,13.6,1.5Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M548.6,251.7l-2.6,4.9-.4-3.6c0-.8,1.5-1.3,3.1-1.2Z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "539.6 251.1 536.2 257.1 537.4 251 539.6 251.1"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M541.9,255.8l-1.2-2.4c-.3-.6,1.5-1.8,2.6-2.1.3,1-.4,2.9-1.4,4.5Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M552.5,257.3c-.7-1.7.6-4.1,2.4-5.3.3,2-.2,3.4-2.4,5.3Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M551.6,253.2l-.7,3.3c0,.4-.9.4-2,.5l.9-3.7c.8-1.2,2.6-1.9,1.7-.1Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M217.5,320.4l-.6-9.9,4.7-1.5-4.5-1.9,4.8-.4v13.4c-.1,1-4.1,1.1-4.5.3Z"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "259.4 323.1 254.6 322.5 254.6 312.5 258.9 312.5 259.4 323.1"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M258.5,310.9h-4.8c0,0,2.1-1.1,2.1-1.1l1.7-.8c.3-.1.8,1.4,1,1.9Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M484.5,219.9l-.9,5.4c-.4,0-1.7.4-1.8,0l-1.3-2.4-.7,2.2c-.2.5-2.6,1-2.6.5l-.6-8.3,11.7-1.4v7.9c0,.7-2.5,1.4-2.6,1l-1-4.9Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M492.9,225.1c-2.1-3.2-2-7,0-10.1,1.3,3.3,1.6,6.5,0,10.1Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M490.2,251.5v2.5c0,.6-4-.3-5.4-1.5s0-3.6.6-4.3l2.4,3.9,1.3-1.6c.2-.2.2,0,1,1Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M472.6,226.5c-2.9-2.9-2.5-6.5-.5-9.4,1.5,2.9,1.8,5.9.5,9.4Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M481.9,255l-2.4-5.6c3.2,0,4.8,2.9,2.4,5.6Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M511.8,252.4c-1,1.5-1.8-45.8.7-37.6l.7,2.2c-.9,11.8,1.3,23.4-1.4,35.4Z"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "187.3 367 181.5 367.2 181.2 354 187.1 353.6 187.3 367"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M194.8,365.1c0,.4-1.2,2.1-1.6,2-.5,0-2.2-.7-2.2-1.2v-11.7c0-.8,3.6-.6,3.6.2l.2,10.7Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M177.4,365.8c0,.5-.8,1.8-1.1,2.2s-2.3-1.4-2.3-2.1v-10.8c0-.4,1.2-1.5,1.5-1.3.5.3,1.8,1.4,1.8,1.9v10.1Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M186.2,351l-4.5-.4,1.4-4.9c.6-2.2,1.4-2.6,1.3,0l1.8,5.2Z"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "486.4 301.2 482.2 301.6 481.7 288.6 486.4 288 486.4 301.2"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M475.7,301.9l-3.9.5-.3-12.2c0-1.1,3.7-1.4,3.7-.4l.5,12.1Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M493.1,301.1l-.2-10.1c0-.7.2-2.8.7-2.8l2.6-.3c.7,0,1,2.3,1,3.2l-.2,8.8c0,.7-2.3,1.1-3.9,1.3Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M487.9,285l-2.6,2.2c-.3.3-1.8-1.7-1.4-1.7l4-.5Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M476.1,286.5c-1.8.4-3.8.4-6.2,0,1.8-.4,3.8-.4,6.2,0Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M481.4,286.5c-1.6.3-1.6.2-.3-.7,2.4-.7,2.6-.2.3.7Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M172.8,271.5c-.8.1-3.3-.7-3.7-1.1l3-3.1c.6-.6-1.2-2.8-1.4-3.5,4.4-5.2-.7-7.4,3.5-10.3l1.1,7.1c-.4,1.9,1.4,1.3,2.3-.1v-15.9c0,0,8.4-1.5,8.4-1.5v7.5c0,0-8.2,2-8.2,2,2.7.4,5.1.2,8.2-.1l.7,9,4.8-.3,1.2,8.8c-6.1-.1-13.6.3-19.9,1.4ZM188.6,268.4c2.9-.8,2-5.8-.6-5.1s-.9,5.5.6,5.1ZM182,268.8c.9,0,2.5-.9,3.2-1.5s-.3-3.8-1.2-3.8c-2.2,0-7.6.3-9.8.7s-1.5,3-.8,3.7,2.6,1.4,3.4,1.3l5.2-.5Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M187.9,278l-2-1.3c-.5-.3-1.5.2-2.2.3s-1.3-.6-1.5-.4l-1.6,1.4h-4.1c0,.1-1.2-1-1.2-1-.2-.2-.5.2-.6.4l-.7,1.7c-1.7-1.1-2.8-4-2.4-6.5l2.9,3.3,2.3-3.5,1.6,3.3c2.2-2.3,5-2.2,6.6-1.5s2,0,2.5,0,.4,1.9.3,3.7Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M189.7,250.8c-1.6-2.3-1.5-5.5.2-7.7,1.6,2.3,1.6,5-.2,7.7Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M174.5,252.1c-3.3-2.1-2.6-5,0-7.3v7.3Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M192,254c-.5,3.3-.4,4.6-2.2,5.8-.8-2.5-.7-4.6-.3-7.7l2.5,1.9Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M492.4,432.8c-1.9,2.6-4.1-8-8.4-7.4s-7,13-9.9,7.4l5.9-7.8c2.6-3.4,6.6-1.1,8.7,1.3l4.7,5.3-1,1.3Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M462.3,204.2l-1.1,4.9v-18.3c2.7,4,2.1,8.7,1.1,13.4Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M548.3,192.3l1.4,17.1-6.4-1,.3-16.5c0-1,2.1-3.9,2.8-3.5l3.1,1.7-3.4.3c-.4,4-.5,8.2.3,12.8l2-10.9Z"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "186.1 320.1 182.5 320.5 181.9 308.5 185.9 308.4 186.1 320.1"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M176.8,318.7c0,.7-.5,2.2-.8,2.6s-2.6-.1-2.6-.7l-.2-10.3c0-.6,1.9-2.2,2.3-1.7s1.2,1.8,1.2,2.4v7.7Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M195.1,319.3l-3.8.3-.4-10.5c0-.9,2.9-1.2,3.5-.8l.7,11Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M193.4,300.9l-2.9-1.1c-.5-.2-2.1.7-2.9.8-1.6,0-2.1-4.8-1.3-5.5l2.2,1.5c.4.3,1.8-1.1,2.3-1.3,1.2-.4,2.2,2.8,2.5,5.6Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M175.8,295.8l.6,5.7c-.8.4-4,.5-4.7-.4s-.9-2.8-.8-5.6l2.7,3.1,2.2-2.9Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M180.2,301.5c-3.5-.3-4.4-3.9-1.8-6.1l1.8,6.1Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M183,301.1c-1.3-.5-2.7-3.9-2.4-5.1l1.7,1.4c.2.2.4.1.6-.1l1.3-1.5c1,.7.4,4.7-1.1,5.2Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M186,305.5c-.9,1.3-3.6,1.8-4.8,1,.8-1.3,2.3-1.6,4.8-1Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M514,199.9c.1,1.7-.4,3.2-2,4.3l.2-18.3c.6,2.7,1.1,5.1,1.3,7.3l.5,6.8Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M237,234.6l-6.6-.9.3-12.8c0-1.2,1.1-3.7,2-4.3s4.2,1.3,4.2,2.6l.2,15.4ZM235.5,221.4c.5-.9-3-2.8-3.4-1.7-.5,1.8,2.7,2.7,3.4,1.7Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M246.2,235.1l-6.1-.8.2-15c.4-.8,3.1-1.4,4-1s1.7,2.5,1.7,3.5v13.4ZM242,221.1c-.6.4,2.1,2.5,2.3,1.8l.4-2.4c0-.5-1.9,0-2.7.6Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M479.2,183.3c-.3,2.8-.2,5.3,0,8.2l2.7-7.4,1.2,7.6-7.1.7.5-9.4c3.1-1.6,6.9-2.3,10.9-1.3l1.5,9.8-5.4.6,1.8-8.9-6.2.2Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M572.1,210.8l-2,2.4c-.2-6.5-.6-11.7.8-18,1.4,4.8,1.1,11.4,1.1,15.6Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M572.1,233c2.5-2.8,2.6,24.6.8,23.8-1.5-8.1-.9-15.6-.8-23.8Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M203.4,307.4c-2.4-2.8-3.8-6.2-3.1-10.5,2.2,2.8,3.6,5.2,3.1,10.5Z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M209.9,305.8c-3.4-1.7-3.3-4.9-.1-7.7v7.7Z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M526.4,301c0,.9-2.4,1.9-2.9,1.5s-1.8-2.4-1.7-3.4v-9.2c0,0,5.6-1.4,5.6-1.4l-5.3-2.5,5.2.6c-.2,1-.6,2.4-.6,3l-.2,11.2Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M431.2,235.6c.2-.5,2.4.9,2.1,1.4l-1,1.9c-.3.5-2.1.3-2-.3s.5-2.4.8-3Z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M415,240.1c-.2.5-2.6-.3-2.3-.8l1.7-3c.5.7,1,2.9.6,3.7Z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M439.8,234.7l2,1c.6.3,0,2.7-.8,2.7s-1.8,0-1.7-.6l.5-3.2Z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M422.6,236.5c.2-.4,1.7.4,1.6.9l-.3,2.2c0,.6-2.6,0-2.4-.6l1.1-2.5Z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M405.3,238.1c.2-.4,2,1.1,1.8,1.6l-.6,1.8c-.2.5-1.7-.1-1.9-.6s.2-1.8.7-2.8Z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M350.9,247c-1.1-.2-1.7-.2-1.7-.7s1-2.8,1.5-2.7,1.6.7,2,.9-.8,1.7-1.7,2.5Z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M360.8,243.9c1,3.6.9,3.7-.4,2.5l-2.3-1.2c-.5-.2,0-1.7.5-1.9s2,.4,2.2.6Z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M366.2,242.9h2.1c.6-.1.8,1.3.8,1.9s-1.6,1.2-1.8.8l-1-2.7Z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M375,242.9c.4-.3,2.3-.5,2.3,0l-.3,1.6c-.1.6-2.4-1.2-2-1.6Z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M684.9,401.3l5,8.6c-2.3-1.9-3.8-4.2-6-7.2-1.9-.7-5.6-.5-7.8-.2l4.3-1.6c1.1-.4.5-3.2.2-4.1,1.5,2.3,3.6,3.3,6.1,2.3s2.8-.7,4.3-.8l-6.2,3.1Z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M616.5,460v45.8c-13.3.8-25.7,1.6-38,2.2-22.2,1.1-44.3,2-66.5,3-5,.2-10,.4-15,.5-14.3.2-28.7.7-43,.4-11.5-.3-23-1.6-34.1-2.4-3-10.4-1.5-19.7,5.9-25.7,6.3-5,14.6-7.8,22.3-10.7,8.1-3,15.5,1.7,22.9,4.1,9.4,3,18.4,7.5,27.6,11.3"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M796.5,451.5c-84.5-.3-169-.7-253.5-1"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M499.5,258c-10,.7-20,1.1-30,2.1-12.7,1.2-25.3-.3-38,1.3-14.6,1.9-29.3,2.5-44,3.7-15.5,1.3-31,2.6-46.5,4-16.7,1.5-33.3,3.1-50,4.5-18.5,1.6-37,3.4-55.5,4.3-8.2.4-16.5-.1-24.5-2.8"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M795.5,460.5c-20.5-.2-41-.3-61.5-.5-17.7-.2-35.3-.4-53-.5-21.2,0-42.3.1-63.5,0-15.7-.1-31.3-.6-47-1-9.2-.2-18.3-.6-27.5-1"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M451.5,267.5c-13.7,1-27.3,1.9-41,3-14,1.1-28,2.4-42,3.5-15,1.2-30,2.3-45,3.5-13.3,1.1-26.7,2-40,3.6-8.2,1-16-1.2-24-1.6-.8,0-1.7,0-2.5,0"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M185.5,488.5c-12.2-4.8-24.3-9.9-36.5-14.4-6.8-2.5-12.7,1.9-18.4,4.6-5.7,2.6-9.7,7.9-12.4,13.4-1.5,3.3-1.2,7.6-1,11.4,0,1.1,2.4,2.6,3.8,2.9,4.1.8,8.3,1.5,12.5,1.5,19,.2,38,.3,57,0,14.8-.3,29.7-1.3,44.5-1.9,14.8-.7,29.7-1.2,44.5-2,7.5-.4,15-1.2,22.5-2.1,1.1-.1,2.8-1.8,2.9-2.9.3-5.9.7-11.8-4.2-16.6-1.6-1.6-1.8-4.5-2.6-6.9"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M242,481.5v-26.5c-75.5,0-152-.4-228.5,1.5"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M125.5,460.5c-29.5.3-59,.7-88.5,1-7.8,0-15.7,0-23.5,0"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M541,452.5c-13.8,0-27.7,0-41.5,0-8.7,0-17.3.5-26,.4-14.7,0-29.3-.3-44-.5"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M520.5,441c-2,.5-4,1.4-6,1.4-24.5,0-49,0-73.5.1-16.5.1-33,.6-49.5,1-7.3.2-14.7.4-22,.5-26.7.4-53.3.7-80,1-12.7.2-25.3.4-38,.5-15.5,0-31,0-46.5,0-12.8,0-25.7.3-38.5.5-12,.2-24,.2-36,.5-12,.3-24,1.1-36,1.4-16,.5-32,.7-48,1-11.3.2-22.7.3-34,.5"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M606.5,361c-.5,2.2-1.4,4.3-1.4,6.5-.1,16,0,32,0,48v26.5"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M452.5,261.5c-.3,9.6-.4,19.2,2.9,28.5.6,1.7-.4,4-.4,6,0,9,0,18,0,27,.1,15.8.4,31.7.5,47.5,0,12-.4,24-.4,36,0,11.7.3,23.3.5,35"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M578.5,332c-.3,1.8-1,3.7-1,5.5,0,34.7,0,69.3,0,104"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M257,445c0-8.3,0-16.7,0-25-.1-10.5-7.6-19.4-17.5-20.4-2.8-.3-5.7.8-8.5,1.4-1.7.4-3.3,1-5,1.5"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M230.5,263.5c-8.3,1-16.7,1.9-25.2,2.9v7.3c6.8-.6,13.3-1.2,19.7-1.8,19.5-1.8,39-3.6,58.5-5.5,12.3-1.2,24.7-2.8,37-3.9,10.3-.9,20.7-1.2,31-2.1,13.2-1.1,26.3-2.7,39.5-3.9,8.8-.8,17.7-1.4,26.5-2,11.3-.8,22.7-1.7,34-2.5"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M261.5,437.5c-.2-5.5-.1-11-.5-16.5-.7-9-3.3-17.2-11.5-22.5-7.8-5-18.5-2.5-24.6,4.4-5.8,6.5-5.1,14.2-5.7,21.6-.6,6.8-.1,13.7-.1,20.5"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M214.5,381.5c.6,21.2.5,42.3.5,63.5"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M170,382.5c0,19.2,0,38.3,0,57.5,0,1.7.3,3.3.5,5"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M277,297.5c0,2.5.1,5,0,7.5-.6,10.5-1.6,21-1.9,31.5-.3,12.2-.2,24.3,0,36.5.2,17.3.6,34.7,1,52,.1,6.5.3,13,.5,19.5"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M247.5,326c0-6,.6-12.1-.2-18-.8-6.2-4.5-7.7-8.8-7.5-3.7.2-6.3,3.7-6.5,8.9-.2,5.2,0,10.3,0,15.5"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M148.5,386.5c.7.2,1.3.5,2,.5,8.8.2,9,.4,9,9.5,0,13.2,0,26.3,0,39.5,0,3,.3,6,.5,9"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M637,387c-.3,2-.9,4-1,6,0,16.3,0,32.7,0,49"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M453.5,215.5c9.2-.8,18.3-1.8,27.5-2.5,12-.9,24-1.7,36-2.5,1.7-.1,3.4.4,4.5.5,0,11-.2,21,0,31,.1,3.7-2.4,7.4.3,11,1.2,1.6,1.2,4.2,2.7,5.3,3.6,2.8,6.6,5.5,6,10.6,0,.8.9,1.7,1.4,2.5,5.9,9.1,12.6,17.7,19,26.5.4.6.9,1.3,1.5,1.5,6.7,1.3,8.7,7.2,11.4,12.1,3,5.5,6.7,10.1,11.6,13.9"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M500,269.5c.8,6,2.1,12,2.4,18,.5,12.2.4,24.3.6,36.5.2,14.5.5,29,.5,43.5,0,24.8-.3,49.7-.5,74.5"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135,332.5c.3,1.8.9,3.7,1,5.5,0,13.2,0,26.3.1,39.5,0,1.9.8,3.8,1.2,5.8"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M348,460c-3.2,3.8-8.1,3-12,3.8-19.9,4.2-39.1,10.5-58,18.2-.3.1-.7.5-1,.5-10.7,0-21.3,0-32,0h-8"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M451.5,227c-8.5,1-17,2.1-25.5,3-8.3.9-16.7,1.7-25,2.5"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M468.5,280c-.2,1.8-.5,3.7-.5,5.5,0,26.3,0,52.7,0,79v77.5"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M217,277.5c1.2,18.5-6,36.4-2.2,56.1,18.9.9,39.2,3.6,59.7,2.9"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M160.5,381.5c11.5-.2,23-.3,34.5-.5,5.3-.1,10.7-1.1,16-.9,11,.4,22,1.4,33,1.8,8.8.3,17.7,0,26.5,0,1.5,0,3,.3,4.5.5"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M528,408c-2.5-4.8.6-12.8,6.6-15.9,1.9-1,4.6-.7,6.9-.6,2.7.1,5.4.6,8.5,1v49.4"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M519.5,317c-.2,9.8-.4,19.7-.5,29.5,0,6.2,0,12.3,0,18.5.1,17.5.6,35,.3,52.5,0,4.8,1.6,8.7,2.6,13,.7,2.9.4,6,.6,9"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M276.5,296.5c-19.9-.2-39.7-1.9-59.5-4.5"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M264.5,288c-.2,6.8-.5,13.7-.5,20.5.2,11.7.8,23.3.9,35,.2,13.2,0,26.3,0,39.5v62"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M542,443.5c0,19.2,0,38.3,0,57.5,0,.8.3,1.7.5,2.5"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M500,212c.2,11,.3,22,.5,33,0,4,.3,8,.5,12"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M206,206c0-7.3,0-14.7,0-22,0-7.2-.8-14.3-.9-21.5,0-3,1.4-6,2.5-9,.2-.6,1.9-1.1,2.9-1,4.9.7,9.7,1.8,14.5,2.4,3.3.4,4.8,2.1,6.1,5,6.3,14.1,12.9,28.1,19.5,42,1.7,3.5,3.9,6.7,5.9,10"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M564.5,220.5c.2,1.8.5,3.7.5,5.5,0,20.2,0,40.3,0,60.5,0,2.7-.6,5.3-1,8"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M164,182c-3.3,9.8-7.4,19.6-7.9,30-.5,10,.2,20,.4,30,0,1.8,0,3.7,0,5.5,0,10,0,20,0,30,0,9.6-2.2,17.8-10.9,23.7-3.7,2.6-6.2,7.2-8.6,11.3-4.5,7.9-10.8,14.2-16.5,21-1,1.2-1.4,3-2,4.5"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M248.5,372v-28.3c-4.6-.2-9.3-.5-14-.7"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M196,240.5v51.2c-3.1.2-6.8.6-10.5.8-10.5.4-21,.7-31.5,1"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M312.5,241c-16.8,1.8-33.5,4-50.5,3.6-3.1,0-6.3,1.9-9.5,2.3-14,1.5-28,2.8-42,4.2v13.8"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M168.5,243c-.2,5.8-.4,11.7-.5,17.5,0,7.7,0,15.3,0,23"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M571,158c2.7,8,5.9,15.9,7.8,24,1.2,5.2.3,11,.2,16.5-.2,20.8-.3,41.7-.5,62.5,0,5.2,4.1,11,9,13.1,1.5.6,2.9,1.8,4,3,7.1,7.6,13.9,15.4,21.1,22.9,4.6,4.8,9.7,9,14.4,13.6,1,1,1.7,2.3,2.5,3.5"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M507,120.5c-5.5,11.2-11,22.3-16.5,33.5-1,1.9-2.3,3.7-3.5,5.5"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M585.5,274.5c-.4,3.8,2.2,6.2,4,9,10,15.7,21.1,30.6,33.6,44.5,9.7,10.7,20,20.7,29.4,31.6,10.9,12.7,24.8,21,39.1,29,4.5,2.5,8.6,5.7,13,8.4,2.7,1.7,5.6,3.1,8.5,4.5,5.5,2.8,10.7,6.5,16.6,8.3,7.9,2.4,14.6,8.2,23.4,7.8,1.8,0,4.1.8,5.4,2,2,2,4.2,2,6.6,1.9"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M519,100.5c2.2,3.8,4.4,7.7,6.5,11.5.4.8,1,1.7,1,2.5-.4,11.5,7.5,19.9,11.2,30,3,8.2,7.5,15.9,10.7,24.1,1.4,3.5,1.3,7.7,5.1,9.5v39"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M214.5,334c0,9.8,0,19.7,0,29.5,0,2.3-.3,4.7-.5,7"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M513,216.5v36"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M567,319.5c-.3,1.7-.9,3.3-1,5,0,13.5-.1,27,0,40.5,0,13,.2,26,.6,39,.1,3.7-1.7,6.4-3.1,9.5-.4.8-1.2,1.9-.9,2.5,3.4,8.4-.3,17.1.9,25.5"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M112,367.5c.3,9.8.6,19.7,1,29.5,0,2,.6,4,1,6"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M168,284.5c0,6.9.4,13.6,2.1,20.6,1.8,7.4.4,15.6.4,23.4,0,13.3,0,26.7,0,40,0,1-.3,2-.5,3"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M510,129c-.4,7.8,3,15.1,2.2,23-.7,7.6.4,15.3.8,23"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M198.5,334.5c.2,15.2.3,30.3.5,45.5"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M204.5,163c-1.5,2-3.3,3.8-4.5,6-4.6,8.5-8.9,17.1-13.7,26.2,3.6,5.7,4,13.2,4.7,20.7.4,4,1.6,8,2.4,12"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M555.5,242.5c6.4,0,2.6,4.4,3.1,7.3-3.3-.3-6.4-.5-9.6-.8-5.8-.6-11.7-1.4-17.5-2-5.4-.5-3.2-4.2-3.2-8,8.9,1,17.5,2,26.2,2.9"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M510,139c-1.3,3.2-2.9,6.2-3.9,9.5-2.5,8.1-4.7,16.3-7.1,24.5"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M502,369.5c-15.3.3-30.7.7-46,1"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M668,408c-.3,1.8-.9,3.7-1,5.5,0,9.5,0,19,0,28.5"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M502,358.5c-11.2.3-22.3.7-33.5,1"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M622.5,317.5c7-.7,11.7,2.4,16.7,7.3,9.3,8.9,19.5,16.9,29.9,24.6,11.2,8.4,22.8,16.3,34.5,24,8,5.3,16.6,9.7,24.9,14.6,1.1.7,2,1.6,3,2.5"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M502,316.5l-46.5,1.5"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M461,148c-3,10.3-7.3,20.5-8.7,31-1.5,11.5-.4,23.3-.3,35,0,6.8.4,13.7.4,20.5,0,2.4-1.3,3.8-3.9,2.5"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M568.5,131.5c0,3.8-.1,7.7,0,11.5.2,4.2.8,8.3.9,12.5,0,2.3-.5,4.7-.4,7,.2,7.5.6,15,1,22.5"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M198.5,381c.2,10.5.3,21,.5,31.5.2,10.8.3,21.7.5,32.5"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M502,421h-33"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M207.5,178c3.2,10.8,6.5,21.6,9.4,32.5.8,3-1.2,3.5-4.4,3.2-5.6-.7-11.3-.2-16.9-.2-.6,6.7-1.1,12.3-1.6,18"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M524.5,441c1.8.5,3.7,1.4,5.5,1.4,42.7,0,85.3.2,128,0,25,0,50-.7,75-.9,13.8,0,27.7.4,41.5.4,7,0,14-.3,21-.5"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135,413.5c.3,1.7.9,3.3,1,5,0,9.2,0,18.3,0,27.5"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M518.5,315.5c.2-6.3,0-12.7.6-19,.8-8.9,2.1-17.7,3.4-27.7-18-2.3-36.4,2.4-54.9,2.7"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M205,175c-1.3,3.3-2.8,6.6-4,10-2.1,6.1-4.1,12.3-6,18.5-.3,1,.3,2.3.4,3.5"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M218,283c6.8.7,13.7,1.5,20.5,2,10.2.8,20.3,1.3,30.5,2,2.7.2,5.3.6,8,1"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M235,199c-6.8.9-6.5.9-7.6,8-1.2,7.2.9,14,1.5,21,.4,4-.2,8-.4,12"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M578,264c-8.7-.2-17.3-.2-26-.5-6.2-.3-12.3-1-18.5-1.5"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M195.5,292.5c1.5,10.5,4.8,20.7,3.5,31.5"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M128.5,326c.8,2.7,2.3,5.3,2.3,8,0,2.2-1.5,4.5-2.8,6.5-5.4,7.9-10.8,15.8-16.5,23.5-4.1,5.5-8.6,10.7-12.9,16-2.5,3.1-5.1,6.3-7.5,9.5-10.5,14.3-24.5,24.6-38.6,34.9-1.9,1.4-4.3,2.1-6.5,3.1"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M231.5,340.5c.2,8.2.3,16.3.5,24.5,0,2,0,4,0,6"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M608,334.5c5.8,4,11.7,8,17.5,12,7.7,5.4,14.3,12.4,23,16.4,2,.9,4.3,1.1,6.5,1.6"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M520,369.5c13,.8,26,1.8,39,2.4,5.8.3,11.7-.3,17.5-.4"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M267,183.5c-1.3,2.8-2.9,5.6-3.9,8.5-2.2,6.4-4.2,12.9-6,19.5-.5,1.8.2,4,.4,6,.6,5.1,1.3,10.3,2.1,16.3-3.2-.5-5.7-.9-8.1-1.3"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M269,185c3,10.3,7,20.5,8.7,31,1.4,8.9,0,18.3-.2,27.5"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M155,295c3.1,6.8,4.7,14.1,4.9,21.5.3,13.7,0,27.3.2,41,0,4.5-2.7,6.8-5.5,9.6-8,7.7-15.5,15.8-23.6,23.4-4.4,4.1-9.7,7.3-14.4,11.1-2.1,1.7-3.7,3.9-5.5,5.9"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M166,161.5c-.3,16.5-.7,33-1,49.5"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M568,152c-3.2,2.6-3,6.5-4.1,10-1.9,6.4-4.5,12.6-6.3,19-1.1,3.9-1.4,7.8.7,12.1,1.9,3.8,1.7,8.5,2.5,13.6-2.4-.5-4.3-.9-6.3-1.3"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M514,147c4.6,13.3,9,26.6,8.1,41-.4,6,0,12-.1,18,0,1.5-.6,3-1,4.5"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M489.5,192c-5.3-1.5-1.1-5-1.5-7.6-2.8-2.6-6.2-2-8.3.3-1.4,1.6-.9,4.8-1.2,7.3h3"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M392.5,453c-7.8-.2-15.7-.4-23.5-.5-17.8,0-35.7-.2-53.5,0-13.3.2-26.7,1-40,1.4-9.8.3-19.7.3-29.5.6-1,0-2,.6-3,1"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M222,416c2.9,5.4,1.9,11.3,2,17,0,3.8-.3,7.7-.5,11.5"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M537,330c4.4.4,8.7.8,13,1.2,0,18.8,0,36.8,0,54.8,0,.8-.3,1.7-.5,2.5"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M198.5,324.5c-8,.3-16,.7-24,1-4.5.1-9,0-13.5,0"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M580,273c-.7,3.5-1.6,7-1.9,10.5-.6,6-.7,12-1.1,18,0,1-.6,2-1,3"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M535.5,319v39"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M235.5,446.5c.2,19.5.3,39,.5,58.5"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M196,282l-39,3"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M733.5,430.5c8.3,1.2,16.7,2.4,25,3.4.9.1,3.8.4,2-2.4"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M450.5,475.5c-8.5,7-13.9,15.8-14.5,27"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M215,238.5c-10.8-3.3-20.9,2.3-31.5,2.2-8.7-.1-17.3,1.2-26,1.8"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M558.5,292c2.7,2,5.4,3.9,8,6,2,1.7,3.7,3.6,5.5,5.5,2,2.1,3.8,4.6,6.1,6.4,3.3,2.7,7,5,10.4,7.6,3.2,2.4,6.1,5.3,9.6,7.4,7.9,4.8,9.7,13.7,14.4,20.6,2.1,3.1,3.7,6.6,5.6,10"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M667,378c0,7.2,0,14.3,0,21.5,0,1.8-.6,3.7-1,5.5"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M502,305.5c-11.2.7-22.3,1.3-33.5,2"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M733,391.5c7.3,3.5,14.9,6.6,21.9,10.6,10.4,5.8,21.4,10,32.6,13.9,3,1,6,2,9,3"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M193.5,436c-1.3-.8-2.8-1.5-4-2.5-5.2-4.8-5.9-4.8-10.5.5-2.8,3.2-5.6,6.3-3.5,11"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M249,206c1.8,12,1.8,24,1,36"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M577,327.5c1.2,1.5,2.2,3.1,3.5,4.5,8.7,9.4,17.4,18.8,26.3,28,4.1,4.2,8.7,7.9,13.2,11.5,11.6,9.3,22.9,19,35.1,27.4,12.4,8.5,25.4,16.1,39.9,20.7,9.4,2.9,18.7,6,28,8.9,1.4.4,3,0,4.5,0"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M767,422.5c7.3,1.7,14.7,3.2,22,5.1,1.7.4,3,2.1,4.8,3.4-4.6,3.3-21.3,4.4-32.3,2.6"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M327,226.5c-.2,1.7-.1,3.4-.5,5-.6,2.4-1.5,4.7-2.5,7-.6,1.3-1.4,3-2.5,3.4-3.7,1.3-3.7,4-3.5,7.1.3,4.5.4,9,.5,13.5"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M148.5,300.5c-.3,2.3,0,5-1.1,6.9-4.1,7.6-8.5,15.1-13,22.5-.7,1.3-2.3,2-3.4,3"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M88,395.5c.3,6,.6,12,1,18,.2,2.2.6,4.3,1,6.5"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M637,357c-.3,3.3-.7,6.7-1,10-.4,4.8-.7,9.7-1,14.5"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M123.5,338c-5.9-.2-9.6,2.4-12.2,7.9-1.5,3.1-5.2,5-7.8,7.6-6.6,6.9-12.4,14.7-19.7,20.8-12.8,10.9-24.6,22.8-38.2,32.9-10.3,7.6-20.9,14.4-31.6,21.3-.5.3-.7,1.3-1,2"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M466.5,215.5c.2,14.8.3,29.7.5,44.5"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M134.5,389c.3,2,.9,4,1,6,.2,3.2-.8,6.6.2,9.4,2.1,5.9-1.6,8.4-5.2,11-3.9,2.8-7.9,5.5-12,8-1.2.7-3.6,1.1-4.3.4-1.2-1.1-1.8-3.1-2.1-4.9-.4-3.5-.4-7-.6-10.5"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M695.5,397.5c1.5-.4,3-.7,4.5-1.1,0,6.5.1,12.8,0,19.1,0,1.7-.9,3.3-1.4,5"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M564,408.5c-1.7-4.2-3.3-8.3-5-12.5-2.2-5.6-9.6-8.5-16.5-7.9-1.1,0-2,1.3-3,1.9"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M640.5,359c-1.3,5.5,3.3,8.7,5.2,12.9,2.9,6.5,7.1,12.4,10.8,18.6"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M533,191.5v22.5"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M144.5,476.5c-7.7,5.2-12.1,12.7-14.5,21.5"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M534.5,441.5c-.2-8.2,0-16.4-.6-24.5-.2-3.3-1.9-6.5-2.9-9.8-.6,0-1.2-.2-1.8-.2-1.7,2.9-3.4,5.7-5.1,8.6"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M465,150c2,5.8,3.9,11.7,6.1,17.5.4,1.2,1.6,2,2.4,3"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M551,240.5c-.2-4.2-.3-8.3-.5-12.5-.1-2.2.1-5.2-1.1-6.3-1.8-1.5-4.8-1.7-7.3-2.2-1.3-.3-2.7,0-4.5,0v19.5"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M573.5,234.5c.2,7.3.3,14.7.5,22"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M245,225.5c.3-.5,1-1,.9-1.5-.2-1.4-.5-2.7-1-4,0-.2-2.2.1-2.3.5-.3,1.1-.5,2.5,0,3.4,1.7,3.6,2.5,7,0,10.5"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M532,217.5c-1,7.1-1.5,14.3-.5,21.5"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M493,178c1.2,8.2,2.3,16.3,3.5,24.5"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M494.5,432.5c-1.7-1.3-3.6-2.4-4.9-4-3.7-4.6-5.2-4.7-9,0-1.4,1.8-2.7,3.7-4,5.5"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M217,239.5c9.7,1,19.3,1.9,29,3.1,4,.5,8,1.6,12,2.4"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M550.5,393.5c5.3,2.7,7.5,7.4,8.5,13,.4,2.4,1.3,4.7,2,7"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.5,417c.6,5.2-4.2,7.5-6.1,11.4-1.4,2.9-3.7,5.5-5.9,8-1.2,1.3-2.9,2.1-4.4,3.1"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M711.5,408.5c5,5.5,10.2,10.8,14.9,16.6,1.8,2.2,2.2,5.5,6.1,4.9"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M555,221.5v20.5"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M550.5,191.5c-2.7-1.9-4.8-1.4-4.9,2-.1,5.6-1.7,11.7,3.9,16"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M509.5,462c-10.3-.2-20.7-.3-31-.5"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M198,371c-12.5.2-25,.3-37.5.5"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M521.5,256c-6.2.3-12.3.7-18.5,1-.8,0-1.7.2-3.2.3.2,3.8.4,7.5.7,11.2"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M642.5,329c.2,1.5-.1,3.3.6,4.5,4.9,8.1,9.9,16.1,15,24,1.9,2.9,2.9,5.8,1,9"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M518.5,87.5c-.2,3.8-.4,7.7-.7,12.4-2,2.8-4.7,6.4-7.3,10.1"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M538.5,284c-.7,2.7-1.7,5.3-1.9,8-.4,5-.4,10-.6,15"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M473,229.5c-.2,5.7-.4,11.3-.6,16.7,6.7-.4,13.4-.9,20.1-1.2,1.7,0,3.3.3,5,.5"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M522.5,212.5c8.2,1.3,16.3,2.6,24.5,4,3.2.5,6.3,1.6,9.5,1.9,5,.6,10,.7,15,1.1,2.2.2,4.3.6,6.5,1"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M276.5,483c.2,6.7.3,13.3.5,20"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M397.5,467c-2.5-.3-5-.5-7.5-1-11-2.1-21.9-4.8-33-6.3-6.8-.9-13.7-1.5-20.5-2.4-4.8-.6-10,1.7-15,2.7-10.7,2.2-21.3,4.3-32,6.5"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M258,455.5v20c-.4.2-.9.4-1.3.6-4.4-6.4-8.8-12.7-13.2-19.1"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M578,276l-33-1.5"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M126.5,448c.2,1.7.5,3.3.5,5,0,9.2,0,18.3,0,27.5"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M567,408.5c3.3,3.1,4.8,6.8,4.1,11.5-.4,2.3,0,4.7,0,7"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M216,291.5c-6.3-1.8-12.6-1.3-19-.5"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M217,392.5c1.4-2.5,2.9-4.9,4.7-8.1,3.7,4.7,1.5,9.1,2.6,13.4-3.4.2-6,1-7.3-2.3"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M216,281.5h-19"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M451.5,232c-7.8.8-15.7,1.8-23.5,2.5-8.5.8-17,1.4-25.5,2"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M328.5,238.5c.8.8,1.7,2.4,2.5,2.4,5.8,0,5,3.9,5,7.6,0,4.2.3,8.3.5,12.5"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M64,394c.3,3.3.6,6.7,1,10,.3,2.8.7,5.7,1,8.5"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M471.5,188h-18.5"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M578,193c-4.8-.3-9.7-.8-14.5-.9-1.3,0-2.7.9-4,1.4"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M412.5,453c.2,4.2.3,8.3.5,12.5,0,2,.3,4,.5,6"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M606,310.5c-.2,2.5-.2,5-.5,7.5-.4,3.5-1,7-1.5,10.5"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M700,373c-.2,4.2-.3,8.3-.5,12.5,0,1.8-.3,3.7-.5,5.5"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M531,264.5c4.5,3.7,9.2,7.1,13.4,11.1,3,2.8,5.1,6.6,8.1,9.3,5.1,4.4,6.3,9.5,3.9,15.6"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58.5,398c-.2,1.8.2,4-.6,5.5-3.4,6.5-8.1,12.4-10.7,19.1-4.6,11.7-15.3,12-24.7,14.9"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M168,183c2.3,6,4.7,12,7,18"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M700.5,423c-.2,6-.3,12-.5,18"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M668,350.5c-.3,3.8-.6,7.7-1,11.5-.2,2.2-.6,4.3-1,6.5"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M64,417c.5,5.8,1.2,11.7,1.4,17.5.2,4.5-.3,9-.4,13.5"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M276.5,220.5h-17.5"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M582,313.5c.2,1.2,0,2.5.5,3.5,4.2,7.7,8.8,15.3,12.8,23.1,1,1.9.5,4.6.6,6.9"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M734,412.5c-.3,2.2-.9,4.3-1,6.5-.1,7.3,0,14.7,0,22"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M264,390.5c-1.2-1.3-2.3-2.7-4.1-4.7-1.1,3.1-2.5,5.6-2.7,8.3-.1,1.8,1.2,3.9,2.5,5.3.5.5,2.8-.8,4.3-1.3"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M111.2,429c.2,5.8.5,11.7.8,17.5"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M513.5,187.5v17"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M483,408.5c0,3-2,7,4.5,7.6-.2-2.7-.4-5.2-.5-7.6"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M114,424.5c-4.6,6.3-11.9,7.5-18.5,10-1.8.7-3.7,1.3-5.5,2"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M606,336.5c-.2,2.2-.3,4.3-.5,6.5-.4,3.5-1,7-1.5,10.5"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M152.5,371c-.5,2.8-.5,5.9-1.6,8.5-3,6.8-6.7,13.3-9.8,20.1-.8,1.7-.4,4-.6,6"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M158,389.5c-6.3,6-12.7,12-19,18-.5.5-1.3.7-2,1"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M462.5,192.5v17"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M425,459.5c.2,6,.3,12,.5,18,0,1.8,0,3.7,0,5.5"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M215,324.5c13.3.8,26.7,1.7,40,2.5,3,.2,6,.3,9,.5"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M198,427c-5.5.2-11,.3-16.5.5"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M83.5,376c-.7,3-1.1,6.1-2.1,9-1,2.8-2.6,5.4-3.9,8"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M323,237.5c-1.3.6-2.5,1.2-4,1.9-.9-1.9-1.7-3.4-2.6-5.1-3.4,1.7-2.9,4.9-2.8,7.7,0,7,.3,14,.5,21"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M88,372.5c.3,3.3.6,6.7,1,10,.2,2,.6,4,1,6"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M390.5,237.5c-16.3,1.5-32.7,3-49,4.5"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M721.5,392.5c3.5-.3,7-.7,10.5-1v16.5"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M572,197.5c-.2,5.3-.3,10.7-.5,16"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M200,370c8.7.5,17.3,1.1,26,1.5,16.2.6,32.3,1,48.5,1.5"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39,414.5c.3,3,.6,6,1,9,.3,2.3.7,4.7,1,7"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M173,218c-5.3.2-10.7.3-16,.5"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M129.5,393c-.5,2-.7,4.2-1.6,6-1.7,3.5-3.9,6.9-5.9,10.4-3.2-.4-6.9-.7-10.5-1.5-2.6-.6-4.4.5-4.9,2.6-2,8.3-8.5,13.9-12.6,21-.5.9-.7,2-1,3"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M543.8,161c-2.8,4.2-6.4,7-11.7,5.8-1.5,8-4,15.3,0,22.7"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M520,305.5c7.2.8,14.3,1.7,21.5,2.5,3.5.4,7,.9,10.5.9,2.5,0,5-.6,7.5-.9"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M88,437.5c-6.5,1.5-13,3-19.5,4.5-.8.2-1.7-.3-2.5-.5"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M185,193c-.8-.8-1.7-1.7-2-2-11.1,11.7-8.7,26.1-9.6,40h-3.9"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M312.5,256.5c-7.2.7-14.3,1.4-21.5,2-3.3.3-6.7.4-10,.5-4.2.2-8.3.3-12.5.5"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M564.5,427.5h8.5v14.5"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M504,315.5c5.6-.6,10.9-.3,16.5.8,9,1.7,18.3,1.9,27.5,2.7,5.8.5,11.7,1,17.5,1.5"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M556.5,321c-1,2.9-1.9,5.8-2.9,8.7-.3,0-.6,0-.9-.1-.4-1.4-.7-2.8-1.3-5-3.9.5-7.9,1-11.9,1.4"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M274,455c-.3,5.2-.7,10.3-1,15.5"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M164,222.5v15"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40,433c.3,5,.7,10,1,15"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M576.5,360c-15.5-.5-31-1-46.5-1.5-8.7-.3-17.3-.7-26-1"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M680.5,368.5c2.8,4.3,5.8,8.6,8.4,13,1.1,1.9,1.4,4.3,2.1,6.5"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M396.5,453.5c.2,3.2.5,6.3.5,9.5,0,3,1.2,5.1,4.1,6,7.8,2.4,15.7,4.7,23.5,7"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M539,193c-2.8,3.4-2.8,9.2.5,14.2v-18.8c-2.8.9-4.9,1.5-7,2.1"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M525.5,121c-5.8-.7-11.7-1.3-17.5-2"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M668,376c-5.3,2-10.6,4.1-16,6-3.7,1.3-7.7,2-11.5,3"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105.5,411c-5.7,3.8-11.3,7.7-17,11.5-1.3.9-2.7,1.7-4,2.5-1.9,1.2-3.6,2.1-4.2,4.9-1.1,4.6-5.2,6-9.3,4.1"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M541,220.5v19.5"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M260.5,455c3.5,4.8,7,9.7,10.5,14.5"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M219.5,352.5v18.5"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M257.5,250.5c-.2,3-.2,6-.6,9,0,.6-1.2,1.4-1.9,1.5-5.3.8-10.7,1.4-16,2-.4,0-1-.9-1.5-1.4"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M480.5,168.5c-1,2.9-2,.9-3.1,0,1.8-3.5,3.6-7,5.9-11.6,1.7,2.1,2.9,3.6,4.1,5.2.5.7.9,1.8,1.5,1.9,8.8,1.3,7.2,8.9,9.1,14.5,2.1,6.2.2,12.4.9,18.5.5,4.7.7,9.3,1,14"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M565,337c-3.8-1.3-6,.6-6,5.5,0,5.5,0,11,0,16.5"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M287,467c-1.2.5-2.3,1.1-3.5,1.5-8.3,2.4-16.7,4.7-25,7"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M215.5,214.5c.2,5.5.4,11,.5,16.5,0,6.3,0,12.7,0,19"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M518,304.5h-14"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M80,428c-2.2.8-4.4,1.5-6.5,2.5-2.6,1.2-5,2.6-7.5,4"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M179,222.5c1.7.3,3.5,1.2,5,.8,1.2-.3,3.1-2.8,2.9-3.2-1.2-1.9,1.5-6-2.8-6-2,0-4.1.9-6,1.4.3,5.3.6,10.2.9,14.7h8.6c.1-1.4.3-3.1.5-4.8"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M546,221.5c-.2,6.2-.3,12.3-.5,18.5"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M504,368.5h14"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M697.5,371c-2.7.3-5.3.7-8,1-2,.2-4,.3-6,.5"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M466.5,271.5h-13.5"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M341.5,247c-.3-2.8-.7-5.7-1-8.5-.3-2.2-.5-4.4-.8-7-1.3.6-1.9.7-2.2,1.1q-4.3,5.2-9.5-1"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M632.5,355l-13.5,1.5"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M196.5,464c-8.7.2-17.3.3-26,.5"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M521.5,176.5c-4.7-.3-9.3-.7-14-1-2.8-.1-5.7,0-8.5,0"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M637,325.5c-.3,2.3-.6,4.7-1,7-.3,2-.7,4-1,6"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M578,312c-.3,1.7-.9,3.3-1,5-.2,3,0,6,0,9.3,2.3.2,5.7.4,9,.7"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M525.5,302.5v-10.5c-1.2-.2-2.1-.4-3-.5"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M526,357c0-2.7,0-5.3,0-8,0-1.2-.3-2.6-1-3.5-3.9-4.7-4.1-7.6-.4-13,5.3,3.8,5.5,6.7,1,13"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M176,309.5v13"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M213,323.5h-13"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M200,332.5h13"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M409.5,453c-12.8-2.4-17.3-.6-26.5,10.5"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M107.5,351c.3,5.5-2.7,9.9-4.9,14.5-2.2,4.6-5.6,8.9-4.6,14.5"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M184.5,262c2.1.6,4.2,1.2,7,2.1v5.8c-6.6.3-13.8.7-21,1.1"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M767,409c-.2,4.5-.4,9-.5,13.5,0,3.7,0,7.3,0,11"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87.5,424c.7,4.2,1.6,8.3,1.9,12.5.3,3.5-.2,7-.4,10.5"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M424,451.5c-2.8,0-5.7-.2-8.5,0-6,.5-8.5,5.6-12,9.5-1.5,1.7-3,3.3-4.5,5"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M577.5,310c-4.2.7-8.3,1.3-12.5,2"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,476c-4,1.8-8,3.7-12,5.5"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M614,302.5c-1.5,5.3,2.9,8.2,5,12,2.3,4.1,5.1,8,7.4,12.1.5.9,0,2.3,0,3.5"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M459.5,279.5c1,2.2,2.1,4.3,3,6.5.8,1.8,1.4,3.7,2,5.5"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M578,186c-6-.2-12-.3-18-.5-2,0-4-.6-6-1"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M467.5,307.5h-12"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M489.5,164.5c1.3,4,2.7,8,4,12"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M121.5,410c-2.2,4-4.3,8-6.5,12"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M523,345c-.3,4-.7,8-1,12"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M477,168.5c-3.5,1.7-4.1,4-3.7,8,.6,7.1-.5,14.3-.7,21.5,0,1.8.6,3.7.9,5.5"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M548.5,193.5c-.2,4-.3,8-.5,12"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M467.5,359.5h-11.5"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M277,455c3.5,4,7,8,10.5,11.9.4-.1.9-.2,1.3-.3.4-4,.8-8.1,1.2-12.1"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M425,444.5c.2,3.7.4,7.3.4,11,0,1.2-.3,2.6-1,3.5-3,3.9-6.3,7.7-9.4,11.5"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M496,342c-.2,3.8-.3,7.7-.5,11.5"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M523,415.8c1,3.9,2,7.8,3,11.8"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M475,343c.2,3.8.3,7.7.5,11.5"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M716.5,416c-3.7,1.7-7.3,3.3-11,5"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M176.5,356.5v11"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M539,167c-.2,1.3.2,3.2-.6,3.9-5.5,5.1-4.4,11.7-4.4,18.1"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M662.5,346h-11"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16,428.5c.3,4.3.7,8.7,1,13,.1,2.5,0,5,0,7.5"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M391,234c.2,7.3.3,14.7.5,22"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65,435c-3.8,1-7.6,1.5-10.2,5.4-.8,1.2-4.1.8-6.3,1.1"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M259.5,354.5c-.2,5-.3,10-.5,15"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M66,392c3.7.5,7.3,1,11,1.5"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M193.5,355.5v11"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M219,125.5c-1,8.1.9,15.2,7.5,20.5"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M742.5,401.5c3,3,6.3,5.8,8.9,9.1,1.5,1.9,2.1,4.6,3.1,6.9"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M474.2,292c0,3.5.2,7,.2,10.5"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M712.5,388.5c2.7,3.8,5.5,7.6,7.9,11.5.8,1.4.7,3.3,1.1,5"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M401.5,233c-.2,5.7-.4,11.3-.4,17,0,1.7.6,3.3.9,5"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M671,351l4.5,10.5"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M532,191.5c-.8,3.4-1.5,6.8-2.3,10.4-2.7-1-4.7-1.7-6.7-2.4"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M486,169c1.5,2.3,3.5,4.5,4.4,7,.9,2.4,1.8,1.6,3.1,1"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M227,227.5c-2.9,4.3-6.7.7-10,1"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M521,183.5c-7-1.7-14-1.9-21,0"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M549.5,169.5c4.9,1.1,5.4,2.2,3.5,7.5"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M215.5,208c-7.2-1.2-14.3-1.4-21.5.4-2.9.7-6.1.3-7.5-3.4-.8-2.1-2.3-4-3.4-6"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M472.5,181.5c-6.7-.2-13.3-.3-20-.5"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M380.5,453c.2,3.3.3,6.7.5,10"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M201.5,298.5c1,3.3,2,6.7,3,10"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M466.5,261c.2,4.5,0,9,.6,13.5.2,1.9,1.8,3.7,3,5.5.1.2,1.6-.6,2.4-.9"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M162,301.5c1.2,3.3,2.3,6.7,3.5,10"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M251,204c-5.5,1.8-4.5,2.7-6.5-2.5-1-2.7-2.4-5.3-4.4-7.9-4.4,7.5-9.9,14.1-11,22.9"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M218.5,135.5c-2.3,3-4.7,6-7,9-1.7,2.2-2.6,4.7-1.5,7.5"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M494,227.5v9.5"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M274.5,327.5c-3.2.2-6.3.3-9.5.5"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M681,372c-3.2.3-6.3.7-9.5,1"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.5,441c3.2.3,6.3.7,9.5,1"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M100.5,367.5c-1.7.2-3.3.4-5,.5-1.5,0-3,0-4.5,0"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M258,214.5h19"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M158.5,365c1.4,4.2,1.4,18.8,0,23"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M137,387c3.2.3,6.3.7,9.5,1"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M123,409.5c3.2.8,6.3,1.7,9.5,2.5"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M480,228.5v9"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M761.5,408c-3,.8-6,1.7-9,2.5"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M112,348.5c.7,3,1.3,6,2,9"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M446.5,242.5l.8,1.5c-3.3.9-6.6,2.5-9.8-.5"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M494,216.5v9"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M507,280c1.3,2.8,2.7,5.7,4,8.5"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M175.5,254.5c-.2,3-.3,6-.5,9"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M490.5,194.5c.3,5.8.7,11.7,1,17.5"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M509,105.5l1.5,22.5"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M170.5,372.5v9"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M182,417.5c0,1.5-.1,3,0,4.5.3,3.2,2,1.9,3.5,1"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M294.5,454.5c2.3,2.8,4.7,5.7,7,8.5"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M305,246.5c-4.7.2-9.3.3-14,.5-2.3.1-4.7.7-7,.9-1.7.2-3.8-.3-3.5,2.5"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M188,196.5c1.8,0,3.8-.4,4.1,2.5.2,1.4,1.2,2.7,1.9,4"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M515.5,277.5c.8,3,1.7,6,2.5,9"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M304.5,454v8.5"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M549.5,310c-.2,4.8-.3,9.7-.5,14.5"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M437,245c-.3.3-.6.9-1,1-9.8.7-19.7,1.4-29.5,2-1.3,0-2.7-.3-4-.5"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M214.5,371.5c-.2,2.8-.3,5.7-.5,8.5"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M758.5,424c-5.5,1.7-11,3.3-16.5,5"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M648,343.5c-2.8.2-5.7.3-8.5.5"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M280,249c-2.8.3-5.7.7-8.5,1"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M257.5,247c0,.8.3,2.2,0,2.4-1.9,1-4.2,2.8-5.9,2.4-5.9-1.5-9.6,0-11.1,6.2-.2.7-1,1.3-1.5,2"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.5,412c2.8.8,5.7,1.7,8.5,2.5"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M774.5,412.5c.7,3.9,4.5,5.2,6.5,8"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M227,142.5c.2,4.2.3,8.3.5,12.5"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M380.5,250c-4.7.5-9.3,1-14,1.5-4.2.5-8.3,1.3-12.5,1.4-4,.1-8-.1-12,.6"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M241.5,253.5c-5.5-2-7.6-.9-8,4"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M78.5,392.5c2.7.5,5.3,1,8,1.5"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M176,297.5c-.2,1.3-.3,2.7-.5,4-.3.1-.5.3-.8.4-.6-1-1.2-2-1.8-2.9"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M176,394.5c.2,2.7.3,5.3.5,8"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.5,413.5c2.7.8,5.3,1.7,8,2.5"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M173,211.5h-16.5"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M728.5,413c-2.7,1-5.3,2-8,3"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M309.5,454c2.3,2,4.7,4,7,6"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M683.5,401.5c2.3,3,4.7,6,7,9"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M390,249c-2.8.2-5.7.3-8.5.5"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M269,251.5c-.5,5.2-1,10.3-1.5,15.5"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M226,254.5c-4.8.3-9.7.7-14.5,1"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M550,301.5c-.3,2.5-.7,5-1,7.5"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M746,418c1.7,2.3,3.3,4.7,5,7"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M459,282.5c-1,2.3-2,4.7-3,7"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M99.5,425l7.5,3"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M479,170.5c-1.3,2.4-1.7,5.7-5.5,5.5"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M715,392.5l-7.5,1.5"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M90,423c2.5.8,5,1.7,7.5,2.5"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M463,127.5v8"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M490.5,408.5v7"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M488.5,404.5h-7"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M185,345.5c-.4,2.2,1.3,5.2-2.5,6"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M486.5,275.5c0,2.6-.5,6,4,3.5"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M452,237.5v22"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M111,364.5h-7"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M191,244.5c-.2,2.3-.3,4.7-.5,7"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M278,282.5c-.3,4.3-.7,8.7-1,13"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M524,429.5c2.6-3.3,6.3-1.6,9.5-2"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M222,311.5c.5-3.9.4-3.9-3.5-3"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M473,218.5c.2,2.3.3,4.7.5,7"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M276.5,254.5c-2.5-1.3-5.3-2.3-7.4-4.1-1-.9-.8-3.2-1.1-4.9"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M344.5,248.5c-.3-.7-.6-1.3-1.5-3.1-1.1,2.2-2.3,3.6-2.4,5.1-.2,3.5.2,7,.4,10.5"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M522,261.5c-.2,2.3-.3,4.7-.5,7"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M335.5,445.5c.2,3.7.3,7.3.5,11"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M198,414c-2.2.2-4.3.3-6.5.5"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M491,274.5c.3,1.2.6,2.4,1,4,1.1-.6,2.1-1,3-1.5"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M498.5,463v6c2.4-.2,4.7-.3,7-.5"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M766.5,434.5v6.5"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M530,270c-2.2.2-4.3.3-6.5.5"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M707,400c-.7,2.8,1.1,4.6,2.5,6.5"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M691.5,399.5c-2.2.8-4.3,1.7-6.5,2.5"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M471,249c1.2,2.2,2.3,4.3,3.5,6.5"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M373.5,453.5c-1.8,2-3.7,4-5.5,6"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M365,453.5v6.5"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M233,254.2c-2.3-2.2-4.6-.9-6.4.4-1.3.9-2.1,3.1.4,4.4"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M487.5,228.5c-.4,2.2-.9,4.3-1.4,6.8,4.5,1.4,3.3,5.3,3.4,8.7"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M312.5,245c-2.2.5-4.3,1-6.5,1.5"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M179.5,263c-1.8.5-3.7,1-6,1.6.2,2,.3,4.2.5,6.4"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M264.5,281c-.2,2-.3,4-.5,6"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M506.5,277.5l-3,9"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M551,285.5l-3,6"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M255.5,277c.3,3,.7,6,1,9"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M480.5,250.5c.8,1.7,1.7,3.3,2.5,5"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M188.5,414.5h-6"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M606,296.5c-.3,2-.7,4-1,6"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M267,165.5c.2,2,.3,4,.5,6"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M257,261.5l1.5,6"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M175,246.5v6"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M484.5,236c-3.1,2.6-6.7,3-10.5,2.5"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M129,333c-4,2.4-6.3,5.6-4.5,10.5"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M540,252c-.8,1.8-1.7,3.7-2.5,5.5"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M616.5,312.5c-1.8-.2-3.7-.3-5.5-.5"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M755,426c1.7,1.5,3.3,3,5,4.5"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M790.5,420c-2.8.3-5.7.5-8.5,1.1-1.7.4-4.7-.6-4.5,2.9"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M237,223.5c.7-3.3-.8-4.7-4.6-4.5.2,1.5.4,3,.6,4.5"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M477,250.5c0,2,.2,3.8,2.5,4.5"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M134,319.5c1.1,1.5,2.2,3,3.2,4.5"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M482,274.5c-1.6,2.7.4,4,2,5.5"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M185,470.5h9.5"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M491.5,397.5v5"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.5,431c-1.7-.7-3.3-1.3-5-2"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M476.5,287.5h-5"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M529.5,217.5c.2,1.7.3,3.3.5,5"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M636,345.5c-.3,1.7-.7,3.3-1,5"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M184,465c.2,1.5.6,3,.4,4.5-.2,1.8-1.3,2-2.4.5"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M191,253.5v7"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M682.5,402c-1.7.5-3.3,1-5,1.5"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M785,422c.7,1.7,1.3,3.3,2,5"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M495.5,273.5c-.6,3.5,0,6.1,4.5,5.5"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M704.5,375c.3,1.5.7,3,1,4.5"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M748.5,410c-1.5.7-3,1.3-4.5,2"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M515,126c-1.8,3.8-5.9,1.5-8.5,3"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M528,289l-4.5-1.5"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M671,377c-.2,1.5-.3,3-.5,4.5"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M485,330c-.2,1.5-.3,3-.5,4.5"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M210,299.5c.2,2.3.3,4.7.5,7"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M184.5,296.5v4c-.3,0-.7,0-1,0-.5-.8-1-1.7-1.5-2.5"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M471.5,200.5c-5.6.4,0,3.9-1.8,5.6,6.2-5.4,13.6-3.3,20.3-4.1"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M693.5,414.5c.3,1.3.7,2.7,1,4"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M186.5,306.5c-1.3.3-2.7.7-4,1"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M601.5,330c-1.3.2-2.7.3-4,.5"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M486.5,249.5c-.3,2.7,0,4.8,3.6,4.1,0-.4.2-1.2.4-2.1"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M472.5,276.5c1.9,3.9,5.2,3.2,8.5,2.5"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M296,248c-.7,1.2-1.3,2.3-2,3.5"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M292,253.5c-.7,1.2-1.3,2.3-2,3.5"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M555.5,253.5c-.5,1.2-1,2.3-1.5,3.5"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M249,257.5c1,1.2,2,2.3,3,3.5"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M228,260c2.2,3.4,4.8,5.5,9,3"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M484,384.5c1.2.2,2.3.3,3.5.5"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M188,296.5c.2,1,.3,2,.5,3.2,1.2-.4,2.3-.8,3.7-1.3.3,1.1.5,2.1.8,3.1"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M740,396c.2,1.2.3,2.3.5,3.5"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M182.5,394.5c-.2,1-.3,2-.5,3"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M382.5,240c1.8,0,1.9,5.7,5,1.5"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M196,306c-1.5.2-3,.3-4.5.5"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M192.5,476.5h-6"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M183.5,276c-1.8.5-3.7,1-5.5,1.5"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M497,176c-1.2.3-2.3.7-3.5,1"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M353.5,247.5c-.2-.5-.3-1-.5-1.5-.8.8-1.7,1.7-2.5,2.5"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M173,275c.8,1.5,1.7,3,2.5,4.5"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M188.5,278.5c-1.3-.7-2.7-1.3-4-2"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M283,252c-.5-.3-1-.7-1.5-1"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M312,253c-.5-.3-1-.7-1.5-1"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M184,274.5c.2,1.3.3,2.7.5,4"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M488.5,167c-.5.3-1,.7-1.5,1"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M225,258.5c-.3.5-.7,1-1,1.5"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M277,255.5c.3.5.7,1,1,1.5"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M275,255.5c-.3.5-.7,1-1,1.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTowerBridge);
export default __webpack_public_path__ + "static/media/tower-bridge.99bc84ea68e5a91a90a72ca3a9465e0e.svg";
export { ForwardRef as ReactComponent };